let isMicroPythonMode = true

var C_imports = []
var C_code = []
var C_init = []

var procedures_codeObj = {}
var oledSensorLineCount = 0
var oledUsedLines = new Set()

//generat each block to corresponding code
function blockToCode({ blockType, params }) {
    const block = codeGenTemplates[blockType]

    if (!block) {
        throw new Error(`Unknown block type: ${blockType}`)
    }

    let imports = block.imports
    let initCode = block.init
    let useCode = block.use

    // Replace all {{PARAM}} tokens
    for (const key in params) {
        const value = params[key]
        const token = `{{${key}}}`

        if (initCode) initCode = initCode.replaceAll(token, value)
        if (useCode) useCode = useCode.replaceAll(token, value)
    }

    return {
        imports: imports,
        initCode: initCode?.trim(),
        useCode: useCode?.trim(),
    }
}

//remove the extenction name tht is present 1st in every block opcode
const removeDeviceName = (str) => {
    const parts = str.split('_')
    return parts.length > 1 ? parts.slice(1).join('_') : str
}
const variableNameMap = {
    'Data 1': 'data_1',
    'Data 2': 'data_2',
    'Flag 1': 'flag_1',
    'Flag 2': 'flag_2',
}

//new block code or create a new function block
//generet the code here
const proceduresToC = (
    target,
    targets,
    procedures_codeObj,
    C_imports,
    C_init,
    variables_data,
    libraryDependentFeatures
) => {
    let procedures_codeArr = []

    let current_pblock = target.next !== null ? targets[target.next] : null
    let protoType = targets[target.inputs.custom_block.block]

    let proccodeData = protoType?.mutation?.proccode
    let funcName = proccodeData?.replace(/%/g, '')?.replace(/\s+/g, '_')

    let argumentIds = JSON.parse(protoType?.mutation?.argumentids ?? '')
    // console.log('VVVVVVVVVVVV', protoType)

    let fun_arguments = []
    argumentIds.map((argumentId) => {
        var block = targets[protoType.inputs[argumentId].block]

        let isMicroPython = true
        if (isMicroPython) {
            fun_arguments.push(block.fields.VALUE.value)
        } else {
            if (block.opcode === 'argument_reporter_string_number') {
                fun_arguments.push(`char * ${block.fields.VALUE.value}`)
            } else {
                fun_arguments.push(`bool ${block.fields.VALUE.value}`)
            }
        }
    })

    const result = blockToCode({
        blockType: 'procedures_prototype',
        params: { FUN_NAME: funcName, FUN_ARGUMENTS: fun_arguments.join(', ') },
    })
    procedures_codeArr.push(result.useCode)

    if (current_pblock !== null) {
        let variables_data_copy = structuredClone(variables_data)
        branch(
            current_pblock,
            targets,
            C_imports,
            procedures_codeArr,
            C_init,
            variables_data_copy,
            libraryDependentFeatures
        )
    }

    procedures_codeArr.push(`return \n\ue001`)

    procedures_codeObj[funcName] = { procedures_codeArr }
}

const extractValue = (
    targets,
    input_value_block,
    imports_array,
    code_array,
    init_array,
    value,
    variables_data,
    libraryDependentFeatures
) => {
    /* eslint-disable */console.log(...oo_oo(`935829992_123_4_123_58_4`,'KKKKKKKKKKK', targets, input_value_block))
    if (targets[input_value_block].fields.NUM !== undefined) {
        value.push(targets[input_value_block].fields.NUM.value)
    } else if (
        targets[input_value_block].fields.VALUE !== undefined &&
        !targets[input_value_block].opcode.includes('input_digital')
    ) {
        value.push(targets[input_value_block].fields.VALUE.value)
    } else if (targets[input_value_block]?.fields?.TEXT !== undefined) {
        value.push(`"${targets[input_value_block].fields.TEXT.value}"`)
    } else if (targets[input_value_block]?.fields?.VARIABLE !== undefined) {
        value.push(
            targets[input_value_block].fields.VARIABLE.value?.replace(
                /\s+/g,
                '_'
            )
        )
    } else {
        var getValue = operator(
            targets[input_value_block],
            targets,
            imports_array,
            code_array,
            init_array,
            variables_data,
            libraryDependentFeatures
        )
        value.push(getValue)
    }
}

const getValue = (
    targets,
    current_bblock,
    imports_array,
    code_array,
    init_array,
    variables_data,
    libraryDependentFeatures
) => {
    let value = []
    // console.log('HHHHHHHHHHHHH', targets, current_bblock)

    Object.keys(current_bblock.inputs).forEach((valueKey) => {
        if (!current_bblock?.inputs?.[valueKey]?.block) {
            value.push('')
        } else {
            let input_value_block = current_bblock.inputs[valueKey].block
            extractValue(
                targets,
                input_value_block,
                imports_array,
                code_array,
                init_array,
                value,
                variables_data,
                libraryDependentFeatures
            )
        }
    })
    return value
}

//for new block create or create a function extrct the arguments
const getArguments = (
    targets,
    current_bblock,
    imports_array,
    code_array,
    init_array,
    variables_data,
    libraryDependentFeatures
) => {
    let value = []
    // console.log('HHHHHHHHHHHHH11111', targets, current_bblock)
    let argumentIds = JSON.parse(current_bblock?.mutation?.argumentids ?? '')

    argumentIds.forEach((argId) => {
        if (!current_bblock?.inputs?.[argId]?.block) {
            value.push('')
        } else {
            let input_value_block = current_bblock.inputs[argId].block
            extractValue(
                targets,
                input_value_block,
                imports_array,
                code_array,
                init_array,
                value,
                variables_data,
                libraryDependentFeatures
            )
        }
    })
    return value
}

const getSubBranch = (target, targets, notOperator) => {
    var branch
    if (notOperator === '!' || notOperator === 'not') {
        branch =
            targets[targets[target.parent].parent].inputs.SUBSTACK === undefined
                ? null
                : targets[
                      targets[targets[target.parent].parent].inputs.SUBSTACK
                          .block
                  ]
    } else {
        branch =
            targets[target.parent].inputs.SUBSTACK === undefined
                ? null
                : targets[targets[target.parent].inputs.SUBSTACK.block]
    }
    return branch
}

/**
 * Special Characters for MicroPython Code Generation
 * --------------------------------------------------
 * In MicroPython, indentation defines code blocks instead of curly braces `{}`.
 * To make Scratch-style block compilation easier, we insert two invisible
 * Unicode "Private Use Area" characters in intermediate code:
 *
 *   \ue000  → BLOCK START marker
 *   \ue001  → BLOCK END marker
 *
 * These characters NEVER appear in valid Python/MicroPython code.
 *
 * Why we use these markers:
 * -------------------------
 * 1. Helps detect where a block begins (e.g., loops, if-blocks)
 * 2. Helps detect where a block ends (equivalent of `}`)
 * 3. Allows building all lines first, then applying indentation logic later
 * 4. Prevents accidental clashes with normal Python syntax
 *
 * During final code generation:
 * -----------------------------
 * - We remove both markers from lines
 * - \ue000 increases indentation AFTER printing the line
 * - \ue001 decreases indentation BEFORE printing the next line
 *
 * Result:
 * -------
 * Properly indented MicroPython code without braces, fully compatible with Python's syntax.
 */
const condition = (
    current_block,
    targets,
    imports_array,
    code_array,
    init_array,
    variables_data,
    libraryDependentFeatures
) => {
    if (!current_block?.opcode?.includes('control')) return

    switch (current_block.opcode) {
        case 'control_forever': {
            if (Object.keys(current_block.inputs).length !== 0)
                forever(
                    targets[current_block.inputs.SUBSTACK.block],
                    targets,
                    imports_array,
                    code_array,
                    init_array,
                    variables_data,
                    libraryDependentFeatures
                )
            if (current_block.next !== null) {
            }
            break
        }
        case 'control_repeat': {
            var args =
                targets[current_block.inputs.TIMES.block].fields.NUM.value
            if (Object.keys(current_block.inputs).length !== 0)
                repeat(
                    args,
                    targets[current_block.inputs?.SUBSTACK?.block],
                    targets,
                    imports_array,
                    code_array,
                    init_array,
                    variables_data,
                    libraryDependentFeatures
                )
            break
        }
        case 'control_wait': {
            var args =
                targets[targets[current_block.id].inputs.DURATION.block].fields
                    .NUM.value
            wait(args, imports_array, code_array)
            break
        }
        case 'control_if': {
            if (current_block.inputs !== null) {
                var args = targets[current_block.inputs?.CONDITION?.block]
                if (args !== undefined) {
                    let operatorValue = operator(
                        args,
                        targets,
                        imports_array,
                        code_array,
                        init_array,
                        variables_data,
                        libraryDependentFeatures
                    )

                    const result = blockToCode({
                        blockType: 'control_if',
                        params: { VALUE: `(${operatorValue})` },
                    })

                    code_array.push(`${result.useCode}`)
                    let notOperator = false
                    let subBranch = getSubBranch(args, targets, notOperator)
                    if (subBranch !== null) {
                        let variables_data_copy =
                            structuredClone(variables_data)
                        branch(
                            subBranch,
                            targets,
                            imports_array,
                            code_array,
                            init_array,
                            variables_data_copy,
                            libraryDependentFeatures
                        )
                    }

                    code_array.push('\ue001')
                }
            } else {
                window.alert('No valid operator in the If or IfElse block.')
            }
            break
        }
    }
}
const inputConditions = (
    sensorC,
    targets,
    imports_array,
    code_array,
    init_array,
    variables_data,
    libraryDependentFeatures
) => {
    ////////////////// ALL INPUT  BLOCK /////////////////////////
    let currentBlockOpcode = removeDeviceName(sensorC.opcode)
    if (
        [
            'input_analog',
            'input_touchpad',
            'input_accelerometer',
            'input_gyro',
            'input_temperature',
            'input_microphone',
            'input_battery',
            'listcontents',
            'itemoflist',
            'itemnumoflist',
            'lengthoflist',
            'listcontainsitem',
            'input_ultrasonic',
            'input_ultrasonic_v2',
            'input_digital_read',
            'input_variable',
        ].includes(currentBlockOpcode)
    ) {
        let params = {}

        switch (currentBlockOpcode) {
            case 'input_analog': {
                params = {
                    PORT: sensorC.fields.PORT.value,
                }
                break
            }

            case 'input_fourinone': {
                break
            }
            case 'input_touchpad': {
                params = {
                    TOUCH: sensorC.fields.PORT.value,
                }
                break
            }
            case 'input_accelerometer': {
                let index = 0
                if (sensorC.fields.PORT.value?.slice(-1) === 'Y') {
                    index = 1
                } else if (sensorC.fields.PORT.value?.slice(-1) === 'Z') {
                    index = 2
                }

                params = {
                    INDEX: index,
                }
                break
            }
            case 'input_gyro': {
                let index = 3
                if (sensorC.fields.PORT.value?.slice(-1) === 'Y') {
                    index = 4
                } else if (sensorC.fields.PORT.value?.slice(-1) === 'Z') {
                    index = 5
                }

                params = {
                    INDEX: index,
                }
                break
            }
            case 'input_microphone':
            case 'input_temperature':
            case 'input_battery': {
                params = {}
                break
            }
            case 'input_ultrasonic':
            case 'input_ultrasonic_v2': {
                let port = sensorC.fields.PORT.value
                params = {
                    PORT: port,
                }
                libraryDependentFeatures.push('ultrasonic')
                break
            }
            case 'input_digital_read': {
                params = {
                    PORT: sensorC.fields.PORT.value,
                }
                break
            }
            case 'input_variable': {
                params = {
                    VAR_NAME: variableNameMap[sensorC.fields.PORT.value],
                }
                break
            }
            // case 'input_battery': {
            // }
            case 'listcontents': {
                const listName = sensorC.fields.LIST?.value
                    ?.trim()
                    ?.replace(/\s+/g, '_')
                return listName
            }
            case 'itemoflist': {
                const listName = sensorC.fields.LIST?.value
                    ?.trim()
                    ?.replace(/\s+/g, '_')

                const values = getValue(
                    targets,
                    sensorC,
                    imports_array,
                    code_array,
                    init_array,
                    variables_data,
                    libraryDependentFeatures
                )

                params = {
                    LIST: listName,
                    INDEX: values?.[0],
                }
                break
            }

            case 'itemnumoflist': {
                const listName = sensorC.fields.LIST?.value
                    ?.trim()
                    ?.replace(/\s+/g, '_')
                let listType = variables_data.listInfo.get(listName) ?? 'STRING'

                const values = getValue(
                    targets,
                    sensorC,
                    imports_array,
                    code_array,
                    init_array,
                    variables_data,
                    libraryDependentFeatures
                )
                let variableValue = values[0]?.replace(/"/g, '') ?? ''

                params = {
                    LIST: listName,
                    ITEM: listType === 'NUMBER' ? variableValue : values?.[0],
                }
                break
            }

            case 'lengthoflist': {
                const listName = sensorC.fields.LIST?.value
                    ?.trim()
                    ?.replace(/\s+/g, '_')

                params = {
                    LIST: listName,
                }
                break
            }

            case 'listcontainsitem': {
                const listName = sensorC.fields.LIST?.value
                    ?.trim()
                    ?.replace(/\s+/g, '_')
                let listType = variables_data.listInfo.get(listName) ?? 'STRING'

                const values = getValue(
                    targets,
                    sensorC,
                    imports_array,
                    code_array,
                    init_array,
                    variables_data,
                    libraryDependentFeatures
                )
                let variableValue = values[0]?.replace(/"/g, '') ?? ''

                params = {
                    LIST: listName,
                    ITEM: listType === 'NUMBER' ? variableValue : values?.[0],
                }
                break
            }
        }

        const result = blockToCode({
            blockType: currentBlockOpcode,
            params,
        })

        if (!imports_array.includes(result.imports))
            imports_array.push(result.imports)
        if (!init_array.includes(result.initCode))
            init_array.push(result.initCode)

        return result.useCode
    } else if (currentBlockOpcode === 'input_fourinone') {
        let sensor = sensorC.fields.PORT.value
        let value = ''
        let initCode2 = ''
        switch (sensor) {
            case 'Red':
            case 'Green':
            case 'Blue': {
                value = `read_color_${sensor.toLowerCase()}`
                if (!init_array.includes('apds.enable_color_sensor()')) {
                    initCode2 = 'apds.enable_color_sensor()'
                }
                break
            }
            case 'Proximity': {
                value = `read_proximity`
                if (!init_array.includes('apds.enable_proximity_sensor()')) {
                    initCode2 = 'apds.enable_proximity_sensor()'
                }
                break
            }
            case 'Light': {
                value = `read_light`
                if (!init_array.includes('apds.enable_light_sensor()')) {
                    initCode2 = 'apds.enable_light_sensor()'
                }

                break
            }
            case 'Gesture': {
                value = `read_gesture`
                if (!init_array.includes('apds.enable_gesture_sensor()')) {
                    initCode2 = 'apds.enable_gesture_sensor()'
                }

                break
            }
        }
        const result = blockToCode({
            blockType: currentBlockOpcode,
            params: {
                VALUE: value,
            },
        })

        if (!init_array.includes(result.initCode))
            init_array.push(result.initCode)
        if (initCode2) {
            init_array.push(initCode2)
        }

        return result.useCode
    }

    if (removeDeviceName(sensorC.opcode) === 'input_shakingstrength') {
        return 'get_shake_strength()'
    }

    if (removeDeviceName(sensorC.opcode) === 'input_ultrasonic') {
        if (
            !C_init.includes(
                `ultrasonic_sensor_t sensor${sensorC.fields.PORT.value}  = ultrasonic_set_port(P${sensorC.fields.PORT.value}1,P${sensorC.fields.PORT.value}2);`
            )
        )
            C_init.push(
                `ultrasonic_sensor_t sensor${sensorC.fields.PORT.value}  = ultrasonic_set_port(P${sensorC.fields.PORT.value}1,P${sensorC.fields.PORT.value}2);`
            )
        return `ultrasonic_read_cm(sensor${sensorC.fields.PORT.value})`
    }
}
const branch = (
    target,
    targets,
    imports_array,
    code_array,
    init_array,
    variables_data,
    libraryDependentFeatures
) => {
    var current_bblock = target

    while (current_bblock) {
        condition(
            current_bblock,
            targets,
            imports_array,
            code_array,
            init_array,
            variables_data,
            libraryDependentFeatures
        )
        if (current_bblock.opcode === 'procedures_call') {
            // console.log('GGGGGGGGGHHHHHHHH', target, targets)

            let funArguments = getArguments(
                targets,
                current_bblock,
                imports_array,
                code_array,
                init_array,
                variables_data,
                libraryDependentFeatures
            )

            // funArguments = funArguments.map((a) => {
            //     if (/^".*"$/.test(a)) {
            //         let replaceA = a?.replace(/"/g, '') ?? ''
            //         if (!isNaN(replaceA) && replaceA !== '') {
            //             return replaceA
            //         }
            //     }

            //     return a
            // })

            let proccodeData = current_bblock.mutation.proccode
            let funcName = proccodeData?.replace(/%/g, '')?.replace(/\s+/g, '_')

            code_array.push(`${funcName}(${funArguments.join(', ')});`)
        }
        // console.log('HHHHHHHHHHHHHXXXXXXXXXXXXXX', current_bblock)
        ////////////////// ALL OUTPUT  BLOCK /////////////////////////
        let currentBlockOpcode = removeDeviceName(current_bblock.opcode)
        if (
            [
                'output_print',
                'output_digital',
                'output_analog',
                'smileLED_output',
                'output_servo',
                'output_motor',
                'output_incremental_servo',
                'output_rgb',
                'output_led',
                'output_set_motor',
                'output_buzzer',
                'output_stop_buzzers',
                'output_oled',
                'output_clear_oled',
                'output_variable',
                'setvariableto',
                'changevariableby',
                'initlist',
                'addtolist',
                'deleteoflist',
                'deletealloflist',
                'insertatlist',
                'replaceitemoflist',
            ].includes(currentBlockOpcode)
        ) {
            let params = {}

            switch (currentBlockOpcode) {
                case 'output_print': {
                    let value = getValue(
                        targets,
                        current_bblock,
                        imports_array,
                        code_array,
                        init_array,
                        variables_data,
                        libraryDependentFeatures
                    )
                    params = {
                        VALUE: value[0],
                    }
                    break
                }
                case 'output_digital': {
                    params = {
                        PORT: current_bblock.fields.PORT.value,
                        VALUE:
                            current_bblock.fields.VALUE.value === 'High'
                                ? 1
                                : 0,
                    }
                    break
                }

                case 'output_variable': {
                    params = {
                        VAR_NAME:
                            variableNameMap[current_bblock.fields.PORT.value],
                        VALUE: current_bblock.fields.VALUE.value,
                    }
                    break
                }

                case 'output_analog': {
                    let value = getValue(
                        targets,
                        current_bblock,
                        imports_array,
                        code_array,
                        init_array,
                        variables_data,
                        libraryDependentFeatures
                    )
                    params = {
                        PORT: current_bblock.fields.PORT.value,
                        VALUE: value[0],
                    }
                    break
                }
                case 'output_servo': {
                    let values = getValue(
                        targets,
                        current_bblock,
                        imports_array,
                        code_array,
                        init_array,
                        variables_data,
                        libraryDependentFeatures
                    )
                    let servoType = current_bblock.fields.MOTOR_TYPE.value

                    let value = values[0]
                    if (servoType == '270') {
                        value = `int(${values[0]} * 0.667)`
                    }

                    params = {
                        PORT: current_bblock.fields.PORT.value,
                        PORT_No:
                            portMaping?.[current_bblock.fields.PORT.value] ??
                            current_bblock.fields.PORT.value,
                        VALUE: value,
                    }
                    break
                }
                case 'output_motor': {
                    let values = getValue(
                        targets,
                        current_bblock,
                        imports_array,
                        code_array,
                        init_array,
                        variables_data,
                        libraryDependentFeatures
                    )
                    let direction = current_bblock.fields.DIRECTION.value

                    let value
                    if (direction === 'ANTI-CLOCKWISE') {
                        value = `int(90 + (${values[0]} / 100) * 90)`
                    } else {
                        value = `int(90 - (${values[0]} / 100) * 90)`
                    }

                    params = {
                        PORT: current_bblock.fields.PORT.value,
                        PORT_No:
                            portMaping?.[current_bblock.fields.PORT.value] ??
                            current_bblock.fields.PORT.value,
                        VALUE: value,
                    }
                    break
                }
                case 'output_incremental_servo': {
                    let values = getValue(
                        targets,
                        current_bblock,
                        imports_array,
                        code_array,
                        init_array,
                        variables_data,
                        libraryDependentFeatures
                    )
                    let value = `int(90 - (${values[0]} / 100) * 90)`

                    params = {
                        PORT: current_bblock.fields.PORT.value,
                        PORT_No:
                            portMaping?.[current_bblock.fields.PORT.value] ??
                            current_bblock.fields.PORT.value,
                        VALUE: value,
                    }
                    break
                }
                case 'smileLED_output': {
                    let ledNum = current_bblock.fields.PORT.value
                    let value =
                        current_bblock.fields.VALUE.value === 'High'
                            ? 'on'
                            : 'off'
                    params = {
                        VALUE: value,
                        LEDNUM: ledNum,
                    }
                    break
                }
                case 'output_led': {
                    // Internal RGB LED block: fields are PORT (eye 1-12) and three
                    // number inputs VALUE1/VALUE2/VALUE3 (R/G/B). getValue resolves
                    // the inputs to [R, G, B]. (The old code read a non-existent
                    // COLOR field, which threw and produced an empty program.)
                    value = getValue(
                        targets,
                        current_bblock,
                        imports_array,
                        code_array,
                        init_array,
                        variables_data,
                        libraryDependentFeatures
                    )
                    params = {
                        INDEX: current_bblock.fields.PORT.value,
                        R: value[0],
                        G: value[1],
                        B: value[2],
                    }
                    break
                }
                case 'output_set_motor': {
                    let portValue = getValue(
                        targets,
                        current_bblock,
                        imports_array,
                        code_array,
                        init_array,
                        variables_data,
                        libraryDependentFeatures
                    )
                    let speed1 = 0,
                        speed2 = 0,
                        port1 = 'Select_Port1',
                        port2 = 'Select_Port2',
                        PORT_No1 = '',
                        PORT_No2 = ''
                    // var portChar =
                    //     current_bblock.fields.PORT.value !== 'Select Port'
                    //         ? current_bblock.fields.PORT.value.charAt(0)
                    //         : 'Select Port'
                    let direction = current_bblock.fields.DIRECTION.value
                    if (direction === 'CLOCKWISE') {
                        speed1 = portValue[0]
                    } else {
                        speed2 = portValue[0]
                    }

                    // for peecee M port maping to the L port, so change the portChar
                    if (current_bblock.fields.PORT.value === 'M1') {
                        port1 = 'M1'
                        port2 = 'M2'
                    } else if (current_bblock.fields.PORT.value === 'M2') {
                        port1 = 'M3'
                        port2 = 'M4'
                    } else {
                        port1 = current_bblock.fields.PORT.value + 1
                        port2 = current_bblock.fields.PORT.value + 2
                    }
                    PORT_No1 = portMaping[port1] ?? 'select_port'
                    PORT_No2 = portMaping[port2] ?? 'select_port'

                    params = {
                        // PORT: portChar,
                        PORT1: port1,
                        PORT2: port2,
                        PORT_No1,
                        PORT_No2,
                        SPEED1: speed1,
                        SPEED2: speed2,
                    }
                    break
                }
                case 'output_motor': {
                }
                case 'output_touchpad': {
                }
                case 'output_rgb': {
                    let value = getValue(
                        targets,
                        current_bblock,
                        imports_array,
                        code_array,
                        init_array,
                        variables_data,
                        libraryDependentFeatures
                    )

                    let index = Number(current_bblock.fields.PORT.value)
                    if (Number.isNaN(index)) {
                        index = current_bblock.fields.PORT.value
                    } else {
                        index = index - 1
                    }

                    params = {
                        INDEX: index,
                        R: value[0],
                        G: value[1],
                        B: value[2],
                    }
                    break
                }
                case 'output_buzzer': {
                    // Buzzer VALUE is a LOCKED_STRING → stored as a field, not an
                    // input, so getValue() (which only reads inputs) returned []
                    // and VALUE came out `undefined`. Read the field directly.
                    params = {
                        VALUE: current_bblock.fields.VALUE.value,
                    }
                    break
                }
                case 'output_oled': {
                    const oledPortRaw = current_bblock.fields.PORT.value

                    if (oledPortRaw === 'Sensor Value') {
                        const sensorPort = current_bblock.fields.VALUE1?.value ?? 'A1'
                        const internalSensorMap = {
                            'Accelerometer X': { init: `qmi8658 = Qmi8658()`, use: `qmi8658.read_xyz()[0]`, initKey: 'qmi8658' },
                            'Accelerometer Y': { init: `qmi8658 = Qmi8658()`, use: `qmi8658.read_xyz()[1]`, initKey: 'qmi8658' },
                            'Accelerometer Z': { init: `qmi8658 = Qmi8658()`, use: `qmi8658.read_xyz()[2]`, initKey: 'qmi8658' },
                            'Gyro X':          { init: `qmi8658 = Qmi8658()`, use: `qmi8658.read_xyz()[3]`, initKey: 'qmi8658' },
                            'Gyro Y':          { init: `qmi8658 = Qmi8658()`, use: `qmi8658.read_xyz()[4]`, initKey: 'qmi8658' },
                            'Gyro Z':          { init: `qmi8658 = Qmi8658()`, use: `qmi8658.read_xyz()[5]`, initKey: 'qmi8658' },
                            'Microphone':      { init: `mic = Mic()`, use: `mic.read()`, initKey: 'mic' },
                            'Temperature':     { init: `temp = ADC(Pin(TEMP_PIN))\ntemp.atten(ADC.ATTN_11DB)`, use: `temp.read()`, initKey: 'temp' },
                            'Battery':         { init: `bat = Battery()`, use: `bat.get_level()`, initKey: 'bat' },
                            'Touch 0':         { init: `t0 = TouchPad(Pin(PORT_T0))`, use: `t0.read()`, initKey: 't0' },
                            'Touch 1':         { init: `t1 = TouchPad(Pin(PORT_T1))`, use: `t1.read()`, initKey: 't1' },
                            'Touch 2':         { init: `t2 = TouchPad(Pin(PORT_T2))`, use: `t2.read()`, initKey: 't2' },
                            'Touch 3':         { init: `t3 = TouchPad(Pin(PORT_T3))`, use: `t3.read()`, initKey: 't3' },
                            'Red':             { init: `apds = Apds()`, use: `apds.read_color_red()`,   initKey: 'apds', extra: `apds.enable_color_sensor()` },
                            'Green':           { init: `apds = Apds()`, use: `apds.read_color_green()`, initKey: 'apds', extra: `apds.enable_color_sensor()` },
                            'Blue':            { init: `apds = Apds()`, use: `apds.read_color_blue()`,  initKey: 'apds', extra: `apds.enable_color_sensor()` },
                            'Proximity':       { init: `apds = Apds()`, use: `apds.read_proximity()`,   initKey: 'apds', extra: `apds.enable_proximity_sensor()` },
                            'Light':           { init: `apds = Apds()`, use: `apds.read_light()`,       initKey: 'apds', extra: `apds.enable_light_sensor()` },
                            'Gesture':         { init: `apds = Apds()`, use: `apds.read_gesture()`,     initKey: 'apds', extra: `apds.enable_gesture_sensor()` },
                        }
                        let sensorInit, sensorRead, initKey
                        const internalEntry = internalSensorMap[sensorPort]
                        if (internalEntry) {
                            sensorInit = internalEntry.init
                            sensorRead = internalEntry.use
                            initKey = internalEntry.initKey
                            if (!init_array.some(e => e.includes(initKey))) {
                                init_array.push(sensorInit)
                            }
                            if (internalEntry.extra && !init_array.includes(internalEntry.extra)) {
                                init_array.push(internalEntry.extra)
                            }
                        } else {
                            const sensorPortBase = sensorPort.slice(0, -1)
                            let sensorKind = 'analog'
                            const varName = `port_${sensorPort}`
                            for (const blk of Object.values(targets)) {
                                const op = removeDeviceName(blk.opcode ?? '')
                                if (op === 'input_digital' && blk.fields?.PORT?.value === sensorPort) {
                                    sensorKind = 'digital'
                                    break
                                }
                                if (op === 'input_ultrasonic' && blk.fields?.PORT?.value === sensorPortBase) {
                                    sensorKind = 'ultrasonic'
                                    break
                                }
                            }
                            if (sensorKind === 'digital') {
                                sensorInit = `${varName} = Pin(PORT_${sensorPort}, Pin.IN)`
                                sensorRead = `${varName}.value()`
                                initKey = varName
                            } else if (sensorKind === 'ultrasonic') {
                                sensorInit = `sensor_${sensorPortBase} = HCSR04(trigger_pin=PORT_${sensorPortBase}1, echo_pin=PORT_${sensorPortBase}2)`
                                sensorRead = `sensor_${sensorPortBase}.distance_mm()`
                                initKey = `sensor_${sensorPortBase}`
                                if (!imports_array.includes('from hcsr04 import HCSR04')) {
                                    imports_array.push('from hcsr04 import HCSR04')
                                }
                                if (!libraryDependentFeatures.includes('ultrasonic')) {
                                    libraryDependentFeatures.push('ultrasonic')
                                }
                            } else {
                                sensorInit = `${varName} = ADC(Pin(PORT_${sensorPort}))\n${varName}.atten(ADC.ATTN_11DB)`
                                sensorRead = `${varName}.read()`
                                initKey = varName
                            }
                            if (!init_array.some(entry => entry.includes(initKey))) {
                                init_array.push(sensorInit)
                            }
                        }
                        do { oledSensorLineCount++ } while (oledUsedLines.has(String(oledSensorLineCount)))
                        oledUsedLines.add(String(oledSensorLineCount))
                        params = {
                            TEXT: sensorRead,
                            LINE: String(oledSensorLineCount),
                        }
                    } else {
                        var values = getValue(
                            targets,
                            current_bblock,
                            imports_array,
                            code_array,
                            init_array,
                            variables_data,
                            libraryDependentFeatures
                        )
                        const oledLineNum = /Line (\d)/.exec(oledPortRaw)?.[1] ?? '1'
                        oledUsedLines.add(oledLineNum)
                        params = {
                            TEXT: values[0],
                            LINE: oledLineNum,
                        }
                    }
                    break
                }
                case 'setvariableto': {
                    let variableName = current_bblock.fields.VARIABLE.value
                        ?.trim()
                        ?.replace(/\s+/g, '_')
                    let variableType = current_bblock.fields.VAR_TYPE.value

                    variables_data.variableInfo.set(variableName, variableType)

                    let value = getValue(
                        targets,
                        current_bblock,
                        imports_array,
                        code_array,
                        init_array,
                        variables_data,
                        libraryDependentFeatures
                    )

                    let variableValue = value[0]?.replace(/"/g, '') ?? ''
                    params = {
                        VARIABLE: variableName,
                        VALUE:
                            variableType === 'NUMBER'
                                ? variableValue
                                : value[0],
                    }
                    break
                }
                case 'changevariableby': {
                    let variableName = current_bblock.fields.VARIABLE.value
                        ?.trim()
                        ?.replace(/\s+/g, '_')
                    let variableType =
                        variables_data.variableInfo.get(variableName) ??
                        'STRING'
                    let value = getValue(
                        targets,
                        current_bblock,
                        imports_array,
                        code_array,
                        init_array,
                        variables_data,
                        libraryDependentFeatures
                    )

                    let variableValue = value[0]?.replace(/"/g, '') ?? ''
                    // const isNumber =
                    //     !isNaN(variableValue) && variableValue !== ''

                    params = {
                        VARIABLE: variableName,
                        VALUE:
                            variableType === 'NUMBER'
                                ? variableValue
                                : value[0],
                    }
                    break
                }

                case 'initlist': {
                    const listName = current_bblock.fields.LIST?.value
                        ?.trim()
                        ?.replace(/\s+/g, '_')

                    let listType = current_bblock.fields.ITEM_TYPE?.value
                    variables_data.listInfo.set(listName, listType)

                    const lengthValue = getValue(
                        targets,
                        current_bblock,
                        imports_array,
                        code_array,
                        init_array,
                        variables_data,
                        libraryDependentFeatures
                    )

                    params = {
                        LIST: listName,
                        LENGTH: lengthValue?.[0] ?? 0,
                    }
                    break
                }

                case 'addtolist': {
                    const listName = current_bblock.fields.LIST?.value
                        ?.trim()
                        ?.replace(/\s+/g, '_')
                    let listType =
                        variables_data.listInfo.get(listName) ?? 'STRING'

                    const values = getValue(
                        targets,
                        current_bblock,
                        imports_array,
                        code_array,
                        init_array,
                        variables_data,
                        libraryDependentFeatures
                    )
                    let variableValue = values[0]?.replace(/"/g, '') ?? ''

                    params = {
                        LIST: listName,
                        ITEM:
                            listType === 'NUMBER' ? variableValue : values?.[0],
                    }
                    break
                }

                case 'deleteoflist': {
                    const listName = current_bblock.fields.LIST?.value
                        ?.trim()
                        ?.replace(/\s+/g, '_')

                    const values = getValue(
                        targets,
                        current_bblock,
                        imports_array,
                        code_array,
                        init_array,
                        variables_data,
                        libraryDependentFeatures
                    )

                    params = {
                        LIST: listName,
                        INDEX: values?.[0],
                    }
                    break
                }

                case 'deletealloflist': {
                    const listName = current_bblock.fields.LIST?.value
                        ?.trim()
                        ?.replace(/\s+/g, '_')

                    params = {
                        LIST: listName,
                    }
                    break
                }

                case 'insertatlist': {
                    const listName = current_bblock.fields.LIST?.value
                        ?.trim()
                        ?.replace(/\s+/g, '_')
                    let listType =
                        variables_data.listInfo.get(listName) ?? 'STRING'

                    const values = getValue(
                        targets,
                        current_bblock,
                        imports_array,
                        code_array,
                        init_array,
                        variables_data,
                        libraryDependentFeatures
                    )
                    let variableValue = values[0]?.replace(/"/g, '') ?? ''

                    params = {
                        LIST: listName,
                        ITEM:
                            listType === 'NUMBER' ? variableValue : values?.[0],
                        INDEX: values?.[1],
                    }
                    break
                }

                case 'replaceitemoflist': {
                    const listName = current_bblock.fields.LIST?.value
                        ?.trim()
                        ?.replace(/\s+/g, '_')
                    let listType =
                        variables_data.listInfo.get(listName) ?? 'STRING'

                    const values = getValue(
                        targets,
                        current_bblock,
                        imports_array,
                        code_array,
                        init_array,
                        variables_data,
                        libraryDependentFeatures
                    )
                    let variableValue = values[1]?.replace(/"/g, '') ?? ''

                    params = {
                        LIST: listName,
                        INDEX: values?.[0],
                        ITEM:
                            listType === 'NUMBER' ? variableValue : values?.[1],
                    }
                    break
                }
            }

            let result = blockToCode({
                blockType: currentBlockOpcode,
                params,
            })
            // console.log('JJJJJJJJJJJJJ', result)

            //for special case buzzer frequition is 0 the call buzzer.stop
            if (result.useCode === 'buzzer.set_freq(0)') {
                result.useCode = buzzer.stop()
            }
            if (!imports_array.includes(result.imports))
                imports_array.push(result.imports)
            if (!init_array.includes(result.initCode))
                init_array.push(result.initCode)
            code_array.push(result.useCode)

            var next_bblock = current_bblock.next
            current_bblock = next_bblock === null ? null : targets[next_bblock]
            continue
        }

        if (removeDeviceName(current_bblock.opcode) === 'output_motor') {
            var value
            if (
                targets[current_bblock.inputs.SPEED.block].fields.NUM !==
                undefined
            ) {
                if (current_bblock.fields.DIRECTION.value === 'CLOCKWISE') {
                    value =
                        Number(
                            targets[current_bblock.inputs.SPEED.block].fields
                                .NUM.value
                        ) + 100
                } else {
                    value =
                        Number(
                            targets[current_bblock.inputs.SPEED.block].fields
                                .NUM.value
                        ) - 100
                }
            } else if (
                targets[current_bblock.inputs.SPEED.block].fields.VALUE !==
                undefined
            ) {
                if (current_bblock.fields.DIRECTION.value === 'CLOCKWISE') {
                    value = `atoi(${
                        targets[current_bblock.inputs.SPEED.block].fields.VALUE
                            .value
                    }) + 100`
                } else {
                    value = `atoi(${
                        targets[current_bblock.inputs.SPEED.block].fields.VALUE
                            .value
                    }) - 100`
                }
            } else {
                if (current_bblock.fields.DIRECTION.value === 'CLOCKWISE') {
                    value = `atoi(${targets[
                        current_bblock.inputs.SPEED.block
                    ].fields.VARIABLE.value.replace(/\s/g, '')}) + 100`
                } else {
                    value = `atoi(${targets[
                        current_bblock.inputs.SPEED.block
                    ].fields.VARIABLE.value.replace(/\s/g, '')}) - 100`
                }
            }
            code_array.push(
                'servo_set_direction(' +
                    `P${current_bblock.fields.PORT.value}` +
                    ',' +
                    value +
                    ');'
            )
            if (
                !C_init.includes(
                    'enable_servo_on(' +
                        `P${current_bblock.fields.PORT.value}` +
                        ');'
                )
            )
                C_init.push(
                    'enable_servo_on(' +
                        `P${current_bblock.fields.PORT.value}` +
                        ');'
                )
        }

        if (
            removeDeviceName(current_bblock.opcode) === 'output_led_animation'
        ) {
            code_array.push(
                '\tset_led_pattern(ledanimate,' +
                    current_bblock.fields.PORT.value
                        .replace(/\s/g, '_')
                        .toUpperCase() +
                    ');'
            )
            if (!C_init.includes('led_strip_t * ledanimate = rgb_eyes_init();'))
                C_init.push('led_strip_t * ledanimate = rgb_eyes_init();')
        }
        if (
            removeDeviceName(current_bblock.opcode) ===
            'output_led_display_secs'
        ) {
            var value = getValue(
                targets,
                current_bblock,
                imports_array,
                code_array,
                init_array
            )
            var color = hexToRgb(
                targets[current_bblock.inputs.COLOR.block].fields.COLOUR.value
            )
            code_array.push(
                '\trgb_set_hsv_for(ledwithtime,' +
                    current_bblock.fields.PORT.value +
                    ',' +
                    color.r +
                    ',' +
                    color.g +
                    ',' +
                    color.b +
                    ',' +
                    value[0] * 1000 +
                    ');'
            )
            if (
                !C_init.includes('led_strip_t * ledwithtime = rgb_eyes_init();')
            )
                C_init.push('led_strip_t * ledwithtime = rgb_eyes_init();')
        }
        if (removeDeviceName(current_bblock.opcode) === 'output_led_display') {
            var color = hexToRgb(
                targets[current_bblock.inputs.COLOR.block].fields.COLOUR.value
            )
            code_array.push(
                '\trgb_set_hsv(ledwithouttime,' +
                    current_bblock.fields.PORT.value +
                    ',' +
                    color.r +
                    ',' +
                    color.g +
                    ',' +
                    color.b +
                    ');'
            )
            if (
                !C_init.includes(
                    'led_strip_t * ledwithouttime = rgb_eyes_init();'
                )
            )
                C_init.push('led_strip_t * ledwithouttime = rgb_eyes_init();')
        }
        if (removeDeviceName(current_bblock.opcode) === 'output_turnoff_led') {
            code_array.push(
                '\trgb_set_hsv(' +
                    current_bblock.fields.PORT.value +
                    ',' +
                    current_bblock.fields.VALUE.value +
                    ',' +
                    0 +
                    ',' +
                    0 +
                    ',' +
                    0 +
                    ');'
            )
            if (
                !C_init.includes(
                    `led_strip_t * ${current_bblock.fields.PORT.value} = rgb_eyes_init();`
                )
            )
                C_init.push(
                    `led_strip_t * ${current_bblock.fields.PORT.value} = rgb_eyes_init();`
                )
        }
        if (
            removeDeviceName(current_bblock.opcode) === 'output_refresh_pixels'
        ) {
            var variable = current_bblock.fields.PORT.value
            code_array.push(`\trefresh_pixels(${variable});`)
        }
        if (removeDeviceName(current_bblock.opcode) === 'output_playsoundfor') {
            var freq =
                targets[current_bblock.inputs.VALUE1.block].fields.NUM.value
            var time =
                targets[current_bblock.inputs.VALUE2.block].fields.NUM.value
            code_array.push(`buzzer_set_frequency(${freq});`)
            code_array.push('delay_ms(' + time * 1000 + ');')
            if (!C_init.includes('buzzer_init();'))
                C_init.push('buzzer_init();')
        }
        if (removeDeviceName(current_bblock.opcode) === 'output_playsoundat') {
            var freq = getValue(
                targets,
                current_bblock,
                imports_array,
                code_array,
                init_array
            )

            code_array.push('\tbuzzer_set_frequency(' + freq[0] + ');')
            if (!C_init.includes('buzzer_init();'))
                C_init.push('buzzer_init();')
        }
        ////////////////// ACE BLOCKS END //////////////////////

        //////////////////// ZING/HEXAPOD BLOCKS ////////////////////
        if (removeDeviceName(current_bblock.opcode) === 'output_move_forward') {
            code_array.push('set_action(MOVE_FORWARD);')
        }
        if (
            removeDeviceName(current_bblock.opcode) === 'output_move_backward'
        ) {
            code_array.push('set_action(MOVE_BACKWARD);')
        }
        if (removeDeviceName(current_bblock.opcode) === 'output_turnright') {
            code_array.push('set_action(TURN_RIGHT);')
        }
        if (removeDeviceName(current_bblock.opcode) === 'output_turnleft') {
            code_array.push('set_action(TURN_LEFT);')
        }
        if (removeDeviceName(current_bblock.opcode) === 'output_action') {
            var action = current_bblock.fields.PORT.value.replace(/\s/g, '_')
            code_array.push(`set_action(${action});`)
        }
        if (removeDeviceName(current_bblock.opcode) === 'output_mp3') {
            var songNo = getValue(
                targets,
                target,
                imports_array,
                code_array,
                init_array
            )
            code_array.push(`set_song(${songNo[0]});`)
        }
        if (removeDeviceName(current_bblock.opcode) === 'output_serial_servo') {
            var port = current_bblock.fields.PORT.value
            var range =
                targets[current_bblock.inputs.VALUE.block].fields.NUM.value
            var time =
                targets[current_bblock.inputs.TIME.block].fields.NUM.value
            code_array.push(`serial_servo_move(${port},${range},${time});`)
        }
        ////////////////// ZING/HEXAPOD BLOCKS END //////////////////////

        var next_bblock = current_bblock.next
        current_bblock = next_bblock === null ? null : targets[next_bblock]
    }
    return
}
const operator = (
    target,
    targets,
    imports_array,
    code_array,
    init_array,
    variables_data,
    libraryDependentFeatures
) => {
    // console.log('UUUUUUUUUU', target, targets)
    switch (target.opcode) {
        case 'operator_add': {
            let value = getValue(
                targets,
                target,
                imports_array,
                code_array,
                init_array,
                variables_data,
                libraryDependentFeatures
            )

            return `${value[0]} + ${value[1]}`
        }
        case 'operator_subtract': {
            let value = getValue(
                targets,
                target,
                imports_array,
                code_array,
                init_array,
                variables_data,
                libraryDependentFeatures
            )

            return `${value[0]} - ${value[1]}`
        }
        case 'operator_multiply': {
            let value = getValue(
                targets,
                target,
                imports_array,
                code_array,
                init_array,
                variables_data,
                libraryDependentFeatures
            )

            return `${value[0]} * ${value[1]}`
        }
        case 'operator_divide': {
            let value = getValue(
                targets,
                target,
                imports_array,
                code_array,
                init_array,
                variables_data,
                libraryDependentFeatures
            )

            return `${value[0]} / ${value[1]}`
        }
        case 'operator_not': {
            // notOperator = isMicroPythonMode ? 'not' : '!'
            // if (target.inputs.OPERAND !== undefined)
            //     target = targets[target.inputs.OPERAND.block]

            let value = getValue(
                targets,
                target,
                imports_array,
                code_array,
                init_array,
                variables_data,
                libraryDependentFeatures
            )
            return isMicroPythonMode ? `not (${value[0]})` : `!(${value[0]})`
        }
        case 'operator_gt': {
            let value = getValue(
                targets,
                target,
                imports_array,
                code_array,
                init_array,
                variables_data,
                libraryDependentFeatures
            )

            let op1 = value[0]?.replace(/"/g, '') ?? ''
            let op2 = value[1]?.replace(/"/g, '') ?? ''
            return `${op1} > ${op2}`
        }
        case 'operator_lt': {
            let value = getValue(
                targets,
                target,
                imports_array,
                code_array,
                init_array,
                variables_data,
                libraryDependentFeatures
            )

            let op1 = value[0]?.replace(/"/g, '') ?? ''
            let op2 = value[1]?.replace(/"/g, '') ?? ''
            return `${op1} < ${op2}`
        }
        case 'operator_equals': {
            let value = getValue(
                targets,
                target,
                imports_array,
                code_array,
                init_array,
                variables_data,
                libraryDependentFeatures
            )

            let op1 = value[0]?.replace(/"/g, '') ?? ''
            let op2 = value[1]?.replace(/"/g, '') ?? ''
            return `${op1} == ${op2}`
        }

        // case 'input_digital': {
        //     var port = target.fields.PORT.value
        //     var state = target.fields.VALUE.value

        //     const result = blockToCode({
        //         blockType: 'input_digital',
        //         params: {
        //             // NOT_OPERATOR: notOperator,
        //             PORT: port,
        //             VALUE: state === 'HIGH' ? 1 : 0,
        //         },
        //     })
        //     console.log('XXXXXXXXXXXXX', result, port, state)
        //     if (!init_array.includes(result.initCode))
        //         init_array.push(result.initCode)
        //     return result.useCode
        // }
        case 'argument_reporter_boolean': {
            // var cond = target.fields.VALUE.value
            // var notOperator = ''

            // const result = blockToCode({
            //     blockType: 'argument_reporter_boolean',
            //     params: {
            //         NOT_OPERATOR: notOperator,
            //         VALUE: cond,
            //     },
            // })
            // code_array.push(result.useCode)
            // code_array.push(`if (${notOperator}${cond}) {`)
            // var subBranch = getSubBranch(target, targets, notOperator)
            // if (subBranch !== null) {
            //     let variables_data_copy = structuredClone(variables_data)
            //     branch(
            //         subBranch,
            //         targets,
            //         imports_array,
            //         code_array,
            //         init_array,
            //         variables_data_copy,
            //         libraryDependentFeatures
            //     )
            // }
            // code_array.push('}')
            // code_array.push('\ue001')
            // break

            let value = target.fields.VALUE.value
            return value
        }
    }

    if (removeDeviceName(target.opcode) === 'input_digital') {
        var port = target.fields.PORT.value
        var state = target.fields.VALUE.value

        const result = blockToCode({
            blockType: 'input_digital',
            params: {
                // NOT_OPERATOR: notOperator,
                PORT: port,
                VALUE: state === 'High' ? 1 : 0,
            },
        })
        // console.log('XXXXXXXXXXXXX', result, port, state)
        if (!init_array.includes(result.initCode))
            init_array.push(result.initCode)
        return result.useCode
    }
    if (
        (removeDeviceName(target.opcode).includes('input') &&
            !['input_digital'].includes(removeDeviceName(target.opcode))) ||
        target.opcode.includes('data_')
    ) {
        let value = inputConditions(
            target,
            targets,
            imports_array,
            code_array,
            init_array,
            variables_data,
            libraryDependentFeatures
        )
        return value
    }
}
const repeat = (
    args,
    target,
    targets,
    imports_array,
    code_array,
    init_array,
    variables_data,
    libraryDependentFeatures
) => {
    if (args) {
        if (args <= 255) {
            const result = blockToCode({
                blockType: 'control_repeat',
                params: {
                    VALUE: args,
                },
            })
            code_array.push(result.useCode)
            if (target !== undefined) {
                let variables_data_copy = structuredClone(variables_data)
                branch(
                    target,
                    targets,
                    imports_array,
                    code_array,
                    init_array,
                    variables_data_copy,
                    libraryDependentFeatures
                )
            }
            code_array.push('\ue001')
            return
        } else {
            window.alert(
                'Maximum number of allowed repeats in repeat function is 255.'
            )
        }
    } else {
        window.alert(
            'Only digits are allowed inside repeat function(blocks are not allowed).'
        )
    }
}
const forever = (
    target,
    targets,
    imports_array,
    code_array,
    init_array,
    variables_data,
    libraryDependentFeatures
) => {
    // code_array.push('while(true){ ')
    const result = blockToCode({
        blockType: 'control_forever',
    })
    code_array.push(result.useCode)

    if (target !== undefined) {
        let variables_data_copy = structuredClone(variables_data)
        branch(
            target,
            targets,
            imports_array,
            code_array,
            init_array,
            variables_data_copy,
            libraryDependentFeatures
        )
    }
    code_array.push('\ue001')
    return
}
const wait = (args, imports_array, code_array) => {
    if (args * 1000 < 4294967295) {
        var times = args * 1000 //limit to 4294967295
        // code_array.push('delay_ms(' + times + ');')

        const result = blockToCode({
            blockType: 'control_wait',
            params: { VALUE: args },
        })

        if (!imports_array.includes(result.imports))
            imports_array.push(result.imports)

        code_array.push(result.useCode)

        return
    } else {
        window.alert('Maximum wait allowed is only upto 4294967 seconds')
    }
}
export const parseEachBlock = async (targets) => {
    /* eslint-disable */console.log(...oo_oo(`935829992_1828_4_1828_24_4`,targets))
    C_imports = []
    C_code = []
    C_init = []

    procedures_codeObj = {}
    oledSensorLineCount = 0
    oledUsedLines = new Set()
    let libraryDependentFeatures = []
    var current_block = null
    var previous_block = null
    var hat_id = null

    let variables_data = {
        variableInfo: new Map(),
        listInfo: new Map(),
    }

    for (const [key, item] of Object.entries(targets)) {
        // item is an array, so loop it

        if (item.topLevel === true) {
            // console.log('hhhhh', item)
            if (item.opcode.includes('procedures_definition')) {
                proceduresToC(
                    item,
                    targets,
                    procedures_codeObj,
                    C_imports,
                    C_init,
                    variables_data,
                    libraryDependentFeatures
                )
            }

            if (item.opcode.includes('event_whenflagclicked')) {
                hat_id = item.id
            }
        }
    }

    if (hat_id !== null) {
        current_block =
            targets[hat_id].next !== null ? targets[targets[hat_id].next] : null
        previous_block = targets[hat_id]
        try {
            if (current_block.opcode === 'control_forever') {
                // console.log('in forver')
                if (previous_block.opcode != 'event_whenflagclicked') {
                    window.alert('cannot start with foerver ')
                }
            }
        } catch (err) {}
        branch(
            current_block,
            targets,
            C_imports,
            C_code,
            C_init,
            variables_data,
            libraryDependentFeatures
        )
    }

    let final_code = []

    if (C_imports.length > 0) {
        C_imports.push('')
        final_code.push(...C_imports)
    }

    if (C_init.length > 0) {
        C_init.push('')
        final_code.push(...C_init)
    }

    Object.values(procedures_codeObj).map(({ procedures_codeArr }) => {
        final_code.push(...procedures_codeArr, '')
    })

    final_code.push(...C_code)

    /* eslint-disable */console.log(...oo_oo(`935829992_1910_4_1910_27_4`,final_code))
    sessionStorage.setItem('C_code', JSON.stringify(final_code))
    sessionStorage.setItem(
        'libraryDependentFeatures',
        JSON.stringify(libraryDependentFeatures)
    )
}

const controlTabCodeTemplates = {
    control_wait: {
        imports: `from time import *`,
        init: '',
        use: 'sleep({{VALUE}})',
        params: ['VALUE'],
    },
    control_repeat: {
        use: 'for i in range(0, {{VALUE}}):\ue000',
        params: ['VALUE'],
    },
    control_forever: {
        use: 'while True:\ue000',
    },
    control_if: {
        use: 'if {{VALUE}} :\ue000',
        params: ['VALUE'],
    },
    // operator_gt: {
    //     use: 'if {{NOT_OPERATOR}} {{VALUE1}} > {{VALUE2}} :\ue000',
    //     params: ['NOT_OPERATOR', 'VALUE1', 'VALUE2'],
    // },
    // operator_lt: {
    //     use: 'if {{NOT_OPERATOR}} {{VALUE1}} < {{VALUE2}} :\ue000',
    //     params: ['NOT_OPERATOR', 'VALUE1', 'VALUE2'],
    // },
    // operator_equals: {
    //     use: 'if {{NOT_OPERATOR}} {{VALUE1}} == {{VALUE2}} :\ue000',
    //     params: ['NOT_OPERATOR', 'VALUE1', 'VALUE2'],
    // },

    argument_reporter_boolean: {
        use: 'if {{NOT_OPERATOR}} {{VALUE}} :\ue000',
        params: ['NOT_OPERATOR', 'VALUE'],
    },
}

const variableTabCodeTemplates = {
    setvariableto: {
        init: '',
        use: '{{VARIABLE}} = {{VALUE}}',
        params: ['VARIABLE', 'VALUE'],
    },

    changevariableby: {
        init: '',
        use: '{{VARIABLE}} = {{VALUE}}',
        params: ['VARIABLE', 'VALUE'],
    },

    //list code templates
    initlist: {
        init: '',
        use: '{{LIST}} = []',
        params: ['LIST'],
    },

    addtolist: {
        init: '',
        use: '{{LIST}}.append({{ITEM}})',
        params: ['LIST', 'ITEM'],
    },

    deleteoflist: {
        init: '',
        use: 'del {{LIST}}[{{INDEX}}]',
        params: ['LIST', 'INDEX'],
    },

    deletealloflist: {
        init: '',
        use: '{{LIST}}.clear()',
        params: ['LIST'],
    },

    insertatlist: {
        init: '',
        use: '{{LIST}}.insert({{INDEX}}, {{ITEM}})',
        params: ['LIST', 'INDEX', 'ITEM'],
    },

    replaceitemoflist: {
        init: '',
        use: '{{LIST}}[{{INDEX}}] = {{ITEM}}',
        params: ['LIST', 'INDEX', 'ITEM'],
    },

    itemoflist: {
        init: '',
        use: '{{LIST}}[{{INDEX}}]',
        params: ['LIST', 'INDEX'],
    },

    itemnumoflist: {
        init: '',
        use: '{{LIST}}.index({{ITEM}})',
        params: ['LIST', 'ITEM'],
    },

    lengthoflist: {
        init: '',
        use: 'len({{LIST}})',
        params: ['LIST'],
    },

    listcontainsitem: {
        init: '',
        use: '{{ITEM}} in {{LIST}}',
        params: ['LIST', 'ITEM'],
    },
}

const newFunctionCodeTemplates = {
    procedures_call: {
        init: '',
        use: '{{FUN_NAME}} ({{FUN_ARGUMENTS}})',
        params: ['VARIABLE', 'FUN_ARGUMENTS'],
    },

    procedures_prototype: {
        init: '',
        use: 'def {{FUN_NAME}} ({{FUN_ARGUMENTS}}) :\ue000',
        params: ['FUN_NAME', 'FUN_ARGUMENTS'],
    },
}

const codeGenTemplates = {
    ...controlTabCodeTemplates,
    ...variableTabCodeTemplates,
    ...newFunctionCodeTemplates,

    output_print: {
        init: '',
        use: `print({{VALUE}})`,
        params: ['VALUE'],
    },

    output_digital: {
        init: 'port{{PORT}} = Pin(PORT_{{PORT}}, Pin.OUT)',
        use: 'port{{PORT}}.value({{VALUE}})',
        params: ['PORT', 'VALUE'],
    },

    output_variable: {
        // Data 1/Data 2/Flag 1/Flag 2 have no firmware protocol yet — same
        // plain Python variable input_variable() reads.
        init: `{{VAR_NAME}} = 0`,
        use: `{{VAR_NAME}} = {{VALUE}}`,
        params: ['VAR_NAME', 'VALUE'],
    },

    output_analog: {
        imports: `from machine import *`,
        init: `pwm{{PORT}} = PWM(PORT_{{PORT}})`,
        use: 'pwm{{PORT}}.duty_u16(int(655.35 * {{VALUE}}))',
        params: ['PORT', 'VALUE'],
    },

    output_servo: {
        init: `
servo{{PORT}} = PWM(Pin({{PORT_No}}))
servo{{PORT}}.freq(50)

def move_servo(servo, angle):\ue000
    min_pulse = 0.5
    max_pulse = 2.5
    pulse = min_pulse + (angle / 180) * (max_pulse - min_pulse)
    duty = int((pulse / 20) * 65535)
    servo.duty_u16(duty)
        \ue001`.trim(),

        use: ` move_servo(servo{{PORT}}, {{VALUE}})`,

        params: ['PORT', 'PORT_No', 'VALUE'],
    },
    output_motor: {
        init: `
servo{{PORT}} = PWM(Pin({{PORT_No}}))
servo{{PORT}}.freq(50)

def move_servo(servo, angle):\ue000
    min_pulse = 0.5
    max_pulse = 2.5
    pulse = min_pulse + (angle / 180) * (max_pulse - min_pulse)
    duty = int((pulse / 20) * 65535)
    servo.duty_u16(duty)
        \ue001`.trim(),

        use: ` move_servo(servo{{PORT}}, {{VALUE}})`,

        params: ['PORT', 'PORT_No', 'VALUE'],
    },
    output_incremental_servo: {
        init: `
servo{{PORT}} = PWM(Pin({{PORT_No}}))
servo{{PORT}}.freq(50)

def move_servo(servo, angle):
    min_pulse = 0.5
    max_pulse = 2.5
    pulse = min_pulse + (angle / 180) * (max_pulse - min_pulse)
    duty = int((pulse / 20) * 65535)
    servo.duty_u16(duty)
        `.trim(),

        use: ` move_servo(servo{{PORT}}, {{VALUE}})`,

        params: ['PORT', 'PORT_No', 'VALUE'],
    },

    smileLED_output: {
        init: 'smile = SmileLed()',
        use: `smile.{{VALUE}}({{LEDNUM}})`,
        params: ['LEDNUM', 'VALUE'],
    },
    output_led: {
        init: 'eyes = RgbEyes()',
        use: `
eyes.set_pixels(num={{INDEX}}, red={{R}}, green={{G}}, blue={{B}})
eyes.update_pixels()
        `,
        params: ['INDEX', 'R', 'G', 'B'],
    },
    output_set_motor: {
        init: `
pwm{{PORT1}} = PWM({{PORT_No1}})
pwm{{PORT2}} = PWM({{PORT_No2}})`,

        use: `
    pwm{{PORT1}}.duty_u16(int(655.35 * {{SPEED1}}))
    pwm{{PORT2}}.duty_u16(int(655.35 * {{SPEED2}}))
        `.trim(),

        params: ['PORT1', 'PORT2', 'PORT_No1', 'PORT_No2', 'SPEED1', 'SPEED2'],
    },
    output_buzzer: {
        init: 'buzzer = Buzzer()',
        use: `
buzzer.set_freq(int({{VALUE}} * .1111))`,
        params: ['VALUE'],
    },
    output_stop_buzzers: {
        init: 'buzzer = Buzzer()',
        use: `buzzer.stop()`,
    },
    output_rgb: {
        imports: `from machine import *`,
        init: `np = neopixel.NeoPixel(Pin(PORT_B1), 10)`,
        use: `
np[{{INDEX}}] = ({{R}}, {{G}}, {{B}})
np.write()
        `.trim(),
        params: ['INDEX', 'R', 'G', 'B'],
    },
    output_oled: {
        init: 'oled = Oled()',
        use: `
oled.set_text(f"{{{TEXT}}}", 10, ({{LINE}}-1)*17)
oled.show()
        `.trim(),
        params: ['TEXT', 'LINE'],
    },
    output_clear_oled: {
        init: 'oled = Oled()',
        use: `oled.clear()`,
    },

    //for inputs code templets
    input_digital: {
        init: 'port{{PORT}} = Pin(PORT_{{PORT}}, Pin.IN)',
        // use: `if {{NOT_OPERATOR}} port{{PORT}}.value() == {{VALUE}} :\ue000`,
        use: `port{{PORT}}.value() == {{VALUE}}`,
        params: ['PORT', 'VALUE'],
    },
    input_analog: {
        init: `port{{PORT}} = ADC(Pin(PORT_{{PORT}}))
          port{{PORT}}.atten(ADC.ATTN_11DB)`.trim(),
        use: `port{{PORT}}.read()`,
        params: ['PORT'],
    },
    input_touchpad: {
        init: `t{{TOUCH}} = TouchPad(Pin(PORT_T{{TOUCH}}))`,
        use: `t{{TOUCH}}.read()`,
        params: ['TOUCH'],
    },
    input_accelerometer: {
        init: `qmi8658 = Qmi8658()`,
        use: `qmi8658.read_xyz()[{{INDEX}}]`,
        params: ['INDEX'],
    },
    input_gyro: {
        init: `qmi8658 = Qmi8658()`,
        use: `qmi8658.read_xyz()[{{INDEX}}]`,
        params: ['INDEX'],
    },
    input_temperature: {
        init: `temp = ADC(Pin(TEMP_PIN))
temp.atten(ADC.ATTN_11DB)`,
        use: `temp.read()`,
        params: [],
    },
    input_microphone: {
        init: `mic = Mic()`,
        use: `mic.read()`,
        params: [],
    },
    input_battery: {
        init: `bat = Battery()`,
        use: `bat.get_level()`,
        params: [],
    },
    input_fourinone: {
        init: 'apds = Apds()',
        use: `apds.{{VALUE}}()`,
        params: ['VALUE'],
    },
    input_ultrasonic: {
        imports: `from hcsr04 import HCSR04`,
        init: `sensor = HCSR04(trigger_pin=PORT_{{PORT}}1, echo_pin=PORT_{{PORT}}2)`,
        use: `sensor.distance_mm()`,
        params: ['PORT'],
    },
    input_ultrasonic_v2: {
        imports: `from hcsr04 import HCSR04`,
        init: `sensor = HCSR04(trigger_pin=PORT_{{PORT}}1, echo_pin=PORT_{{PORT}}2)`,
        use: `sensor.distance_mm()`,
        params: ['PORT'],
    },
    input_digital_read: {
        init: 'port{{PORT}} = Pin(PORT_{{PORT}}, Pin.IN)',
        use: `port{{PORT}}.value()`,
        params: ['PORT'],
    },
    input_variable: {
        // Data 1/Data 2/Flag 1/Flag 2 have no firmware protocol yet (see
        // output_variable) — represented here as a plain module-level
        // Python variable, shared with output_variable via the same name.
        init: `{{VAR_NAME}} = 0`,
        use: `{{VAR_NAME}}`,
        params: ['VAR_NAME'],
    },
}

//poartMaping for peecee
const portMaping = {
    A1: 1,
    A2: 2,
    B1: 4,
    B2: 5,
    C1: 6,
    C2: 7,
    D1: 8,
    D2: 9,
    E1: 17,
    E2: 14,
    F1: 15,
    F2: 16,
    S1: 10,
    S2: 11,
    M1: 37,
    M2: 41,
    M3: 21,
    M4: 35,
}

export default codeGenTemplates
/* istanbul ignore next *//* c8 ignore start *//* eslint-disable */;function oo_cm(){try{return (0,eval)("globalThis._console_ninja") || (0,eval)("/* https://github.com/wallabyjs/console-ninja#how-does-it-work */'use strict';var _0x13c709=_0x482f;(function(_0x889ddb,_0x2b783c){var _0x29e761=_0x482f,_0x5e9f48=_0x889ddb();while(!![]){try{var _0x20891a=-parseInt(_0x29e761(0x1a1))/0x1+parseInt(_0x29e761(0x181))/0x2*(-parseInt(_0x29e761(0x12b))/0x3)+-parseInt(_0x29e761(0x1d5))/0x4*(-parseInt(_0x29e761(0x193))/0x5)+-parseInt(_0x29e761(0x1c4))/0x6+parseInt(_0x29e761(0x108))/0x7+parseInt(_0x29e761(0x151))/0x8+parseInt(_0x29e761(0x145))/0x9*(-parseInt(_0x29e761(0x16c))/0xa);if(_0x20891a===_0x2b783c)break;else _0x5e9f48['push'](_0x5e9f48['shift']());}catch(_0x4c2964){_0x5e9f48['push'](_0x5e9f48['shift']());}}}(_0x5eac,0x228e6));function z(_0xb433bc,_0x264628,_0x287c5f,_0x269fdc,_0x7ab7da,_0x4a8b22){var _0x439938=_0x482f,_0x3ad9a6,_0x43888d,_0x1209ea,_0xe46c26;this[_0x439938(0x175)]=_0xb433bc,this[_0x439938(0x1d4)]=_0x264628,this[_0x439938(0x1af)]=_0x287c5f,this[_0x439938(0x1c3)]=_0x269fdc,this[_0x439938(0x109)]=_0x7ab7da,this[_0x439938(0x13b)]=_0x4a8b22,this['_allowedToSend']=!0x0,this[_0x439938(0x119)]=!0x0,this[_0x439938(0x129)]=!0x1,this[_0x439938(0x136)]=!0x1,this['_inNextEdge']=((_0x43888d=(_0x3ad9a6=_0xb433bc[_0x439938(0x1a0)])==null?void 0x0:_0x3ad9a6[_0x439938(0x182)])==null?void 0x0:_0x43888d[_0x439938(0xd9)])===_0x439938(0x12e),this[_0x439938(0x14c)]=!((_0xe46c26=(_0x1209ea=this['global'][_0x439938(0x1a0)])==null?void 0x0:_0x1209ea[_0x439938(0x125)])!=null&&_0xe46c26[_0x439938(0x190)])&&!this[_0x439938(0xd7)],this['_WebSocketClass']=null,this[_0x439938(0x13c)]=0x0,this[_0x439938(0x166)]=0x14,this[_0x439938(0x1d6)]=_0x439938(0x1c8),this[_0x439938(0x19a)]=(this[_0x439938(0x14c)]?_0x439938(0x138):_0x439938(0x165))+this['_webSocketErrorDocsLink'];}z[_0x13c709(0xec)][_0x13c709(0x16f)]=async function(){var _0x4bb651=_0x13c709,_0x5d030a,_0xe79488;if(this[_0x4bb651(0xd1)])return this[_0x4bb651(0xd1)];let _0x11a897;if(this['_inBrowser']||this[_0x4bb651(0xd7)])_0x11a897=this['global']['WebSocket'];else{if((_0x5d030a=this['global'][_0x4bb651(0x1a0)])!=null&&_0x5d030a[_0x4bb651(0x186)])_0x11a897=(_0xe79488=this[_0x4bb651(0x175)][_0x4bb651(0x1a0)])==null?void 0x0:_0xe79488[_0x4bb651(0x186)];else try{_0x11a897=(await new Function('path',_0x4bb651(0x12c),'nodeModules','return\\x20import(url.pathToFileURL(path.join(nodeModules,\\x20\\x27ws/index.js\\x27)).toString());')(await(0x0,eval)(_0x4bb651(0x194)),await(0x0,eval)(_0x4bb651(0x11e)),this[_0x4bb651(0x1c3)]))[_0x4bb651(0x1d0)];}catch{try{_0x11a897=require(require(_0x4bb651(0x1c2))['join'](this[_0x4bb651(0x1c3)],'ws'));}catch{throw new Error(_0x4bb651(0x15e));}}}return this[_0x4bb651(0xd1)]=_0x11a897,_0x11a897;},z[_0x13c709(0xec)][_0x13c709(0x141)]=function(){var _0x2d7f3d=_0x13c709;this[_0x2d7f3d(0x136)]||this['_connected']||this[_0x2d7f3d(0x13c)]>=this[_0x2d7f3d(0x166)]||(this[_0x2d7f3d(0x119)]=!0x1,this[_0x2d7f3d(0x136)]=!0x0,this[_0x2d7f3d(0x13c)]++,this['_ws']=new Promise((_0x1ef223,_0x3e284a)=>{var _0xfce03f=_0x2d7f3d;this['getWebSocketClass']()[_0xfce03f(0x15c)](_0x1e23a4=>{var _0x85af02=_0xfce03f;let _0x57e592=new _0x1e23a4(_0x85af02(0x162)+(!this[_0x85af02(0x14c)]&&this[_0x85af02(0x109)]?'gateway.docker.internal':this[_0x85af02(0x1d4)])+':'+this[_0x85af02(0x1af)]);_0x57e592[_0x85af02(0x18d)]=()=>{var _0x28e254=_0x85af02;this[_0x28e254(0x19d)]=!0x1,this[_0x28e254(0xfa)](_0x57e592),this[_0x28e254(0xe9)](),_0x3e284a(new Error(_0x28e254(0x102)));},_0x57e592[_0x85af02(0xd3)]=()=>{var _0x144f32=_0x85af02;this[_0x144f32(0x14c)]||_0x57e592['_socket']&&_0x57e592[_0x144f32(0x1b8)][_0x144f32(0x189)]&&_0x57e592[_0x144f32(0x1b8)]['unref'](),_0x1ef223(_0x57e592);},_0x57e592[_0x85af02(0xf1)]=()=>{var _0x4f4382=_0x85af02;this[_0x4f4382(0x119)]=!0x0,this['_disposeWebsocket'](_0x57e592),this[_0x4f4382(0xe9)]();},_0x57e592['onmessage']=_0x119499=>{var _0x33632d=_0x85af02;try{if(!(_0x119499!=null&&_0x119499['data'])||!this[_0x33632d(0x13b)])return;let _0x487235=JSON['parse'](_0x119499[_0x33632d(0x14f)]);this[_0x33632d(0x13b)](_0x487235[_0x33632d(0x11d)],_0x487235[_0x33632d(0x106)],this['global'],this[_0x33632d(0x14c)]);}catch{}};})[_0xfce03f(0x15c)](_0x23b222=>(this[_0xfce03f(0x129)]=!0x0,this['_connecting']=!0x1,this[_0xfce03f(0x119)]=!0x1,this[_0xfce03f(0x19d)]=!0x0,this['_connectAttemptCount']=0x0,_0x23b222))[_0xfce03f(0x139)](_0x2ea296=>(this[_0xfce03f(0x129)]=!0x1,this[_0xfce03f(0x136)]=!0x1,console[_0xfce03f(0x12f)](_0xfce03f(0x115)+this[_0xfce03f(0x1d6)]),_0x3e284a(new Error('failed\\x20to\\x20connect\\x20to\\x20host:\\x20'+(_0x2ea296&&_0x2ea296[_0xfce03f(0x196)])))));}));},z[_0x13c709(0xec)]['_disposeWebsocket']=function(_0x8470f3){var _0x24bf18=_0x13c709;this[_0x24bf18(0x129)]=!0x1,this['_connecting']=!0x1;try{_0x8470f3[_0x24bf18(0xf1)]=null,_0x8470f3[_0x24bf18(0x18d)]=null,_0x8470f3['onopen']=null;}catch{}try{_0x8470f3[_0x24bf18(0x130)]<0x2&&_0x8470f3[_0x24bf18(0x1bf)]();}catch{}},z[_0x13c709(0xec)][_0x13c709(0xe9)]=function(){var _0x2f6bf7=_0x13c709;clearTimeout(this[_0x2f6bf7(0x192)]),!(this[_0x2f6bf7(0x13c)]>=this[_0x2f6bf7(0x166)])&&(this['_reconnectTimeout']=setTimeout(()=>{var _0xd0844d=_0x2f6bf7,_0x4481e9;this[_0xd0844d(0x129)]||this[_0xd0844d(0x136)]||(this[_0xd0844d(0x141)](),(_0x4481e9=this[_0xd0844d(0x113)])==null||_0x4481e9['catch'](()=>this[_0xd0844d(0xe9)]()));},0x1f4),this[_0x2f6bf7(0x192)]['unref']&&this[_0x2f6bf7(0x192)][_0x2f6bf7(0x189)]());},z[_0x13c709(0xec)]['send']=async function(_0x3217f7){var _0x5c4318=_0x13c709;try{if(!this['_allowedToSend'])return;this[_0x5c4318(0x119)]&&this[_0x5c4318(0x141)](),(await this[_0x5c4318(0x113)])[_0x5c4318(0x133)](JSON[_0x5c4318(0x191)](_0x3217f7));}catch(_0x10ec8c){this[_0x5c4318(0x1d2)]?console['warn'](this['_sendErrorMessage']+':\\x20'+(_0x10ec8c&&_0x10ec8c['message'])):(this[_0x5c4318(0x1d2)]=!0x0,console['warn'](this['_sendErrorMessage']+':\\x20'+(_0x10ec8c&&_0x10ec8c[_0x5c4318(0x196)]),_0x3217f7)),this[_0x5c4318(0x19d)]=!0x1,this[_0x5c4318(0xe9)]();}};function _0x5eac(){var _0x85dc52=['port','timeStamp','_p_length','emulator','fromCharCode',',\\x20see\\x20https://tinyurl.com/2vt8jxzw\\x20for\\x20more\\x20info.','positiveInfinity','_treeNodePropertiesBeforeFullValue','push','_socket','getOwnPropertyDescriptor','_isArray','Set','_objectToString','_p_','noFunctions','close','Console\\x20Ninja\\x20extension\\x20is\\x20connected\\x20to\\x20','call','path','nodeModules','210930brsvgc','reduceOnAccumulatedProcessingTimeMs','strLength','unknown','https://tinyurl.com/37x8b79t','modules','value','_cleanNode','_setNodePermissions','HTMLAllCollection','1.0.0','_getOwnPropertySymbols','default','disabledLog','_extendedWarning','10.0.2.2','host','30284RgRdPc','_webSocketErrorDocsLink','_isPrimitiveType','some','pop','_WebSocketClass','','onopen','reducePolicy','toString','stackTraceLimit','_inNextEdge','reload','NEXT_RUNTIME','_setNodeExpressionPath','isArray','_propertyName','isExpressionToEvaluate','perf_hooks','NEGATIVE_INFINITY','ninjaSuppressConsole','see\\x20https://tinyurl.com/2vt8jxzw\\x20for\\x20more\\x20info.','set','disabledTrace','stack','_dateToString','\\x20browser','elapsed','null','_attemptToReconnectShortly','_isMap','hostname','prototype','cappedElements','_isNegativeZero','depth','current','onclose','angular','_addProperty','capped','defaultLimits','_ninjaIgnoreNextError','rootExpression','undefined','trace','_disposeWebsocket','_isPrimitiveWrapperType','1','expId','1791360514658','53297','ExpoDevice','string','logger\\x20websocket\\x20error','remix','autoExpandMaxDepth','test','args','map','1061921HqdgPy','dockerizedApp','_sortProps','_blacklistedProperty','sort','match','expressionsToEvaluate','cappedProps','_property','object','_getOwnPropertyNames','_ws','%c\\x20Console\\x20Ninja\\x20extension\\x20is\\x20connected\\x20to\\x20','logger\\x20failed\\x20to\\x20connect\\x20to\\x20host,\\x20see\\x20','react-native','slice','getOwnPropertySymbols','_allowedToConnectOnSend','_capIfString','getter','forEach','method','import(\\x27url\\x27)','Buffer','perLogpoint','_isSet','_type','performance','String','versions','_keyStrRegExp','next.js',\"/Users/jovitmathew/.vscode/extensions/wallabyjs.console-ninja-1.0.543/node_modules\",'_connected','name','12123Yaldrj','url','function','edge','warn','readyState','console','valueOf','send','_console_ninja_session','toUpperCase','_connecting','resolveGetters','Console\\x20Ninja\\x20failed\\x20to\\x20send\\x20logs,\\x20refreshing\\x20the\\x20page\\x20may\\x20help;\\x20also\\x20see\\x20','catch','autoExpand','eventReceivedCallback','_connectAttemptCount','root_exp','symbol','_processTreeNodeResult','_undefined','_connectToHostNow','logger\\x20failed\\x20to\\x20connect\\x20to\\x20host','_getOwnPropertyDescriptor','now','13185VXGGUl','negativeZero','replace','autoExpandPropertyCount','indexOf','setter','props','_inBrowser',{\"resolveGetters\":false,\"defaultLimits\":{\"props\":100,\"elements\":100,\"strLength\":51200,\"totalStrLength\":51200,\"autoExpandLimit\":5000,\"autoExpandMaxDepth\":10},\"reducedLimits\":{\"props\":5,\"elements\":5,\"strLength\":256,\"totalStrLength\":768,\"autoExpandLimit\":30,\"autoExpandMaxDepth\":2},\"reducePolicy\":{\"perLogpoint\":{\"reduceOnCount\":50,\"reduceOnAccumulatedProcessingTimeMs\":100,\"resetWhenQuietMs\":500,\"resetOnProcessingTimeAverageMs\":100},\"global\":{\"reduceOnCount\":1000,\"reduceOnAccumulatedProcessingTimeMs\":300,\"resetWhenQuietMs\":50,\"resetOnProcessingTimeAverageMs\":100}}},'serialize','data','Map','1908248mgMtMq','_numberRegExp','expo','get','reduceLimits','substr','iterator','_Symbol','_console_ninja','_treeNodePropertiesAfterFullValue','Boolean','then','resetWhenQuietMs','failed\\x20to\\x20find\\x20and\\x20load\\x20WebSocket','hits','toLowerCase','endsWith','ws://','boolean','reducedLimits','Console\\x20Ninja\\x20failed\\x20to\\x20send\\x20logs,\\x20restarting\\x20the\\x20process\\x20may\\x20help;\\x20also\\x20see\\x20','_maxConnectAttemptCount','time','_addLoadNode','origin','127.0.0.1','_addFunctionsNode','1150kxJZnD','type','bound\\x20Promise','getWebSocketClass','index','[object\\x20Array]','count','level','autoExpandLimit','global','error','parent','_setNodeId','Number','_consoleNinjaAllowedToStart','','elements','resetOnProcessingTimeAverageMs','_regExpToString','bigint','log','52ebAUJI','env','getOwnPropertyNames','length','\\x20server','_WebSocket','_addObjectProperty','_p_name','unref','_setNodeLabel','Symbol','constructor','onerror','_setNodeExpandableState','totalStrLength','node','stringify','_reconnectTimeout','175CQnGtI','import(\\x27path\\x27)','_hasSetOnItsPath','message','Error','allStrLength','background:\\x20rgb(30,30,30);\\x20color:\\x20rgb(255,213,92)','_sendErrorMessage','sortProps','location','_allowedToSend','array','reduceOnCount','process','204981dzJdbH','concat','nan','_hasMapOnItsPath','autoExpandPreviousObjects','number','_quotedRegExp','_HTMLAllCollection','[object\\x20Map]','_setNodeQueryPath','hrtime','date','split','bind'];_0x5eac=function(){return _0x85dc52;};return _0x5eac();}function H(_0x3a961e,_0xd078b1,_0x5001fa,_0x53bf17,_0x88bcb3,_0x4f92ce,_0x22a86b,_0x4a7f1a=ne){var _0x1231a7=_0x13c709;let _0x459821=_0x5001fa[_0x1231a7(0x1ad)](',')['map'](_0x21044f=>{var _0x16cf1b=_0x1231a7,_0x54875f,_0xa7b963,_0x3e9195,_0x15e8ee,_0x10a097,_0x439ee7,_0x4c4ef2,_0x4624e9;try{if(!_0x3a961e['_console_ninja_session']){let _0x34dcff=((_0xa7b963=(_0x54875f=_0x3a961e[_0x16cf1b(0x1a0)])==null?void 0x0:_0x54875f[_0x16cf1b(0x125)])==null?void 0x0:_0xa7b963[_0x16cf1b(0x190)])||((_0x15e8ee=(_0x3e9195=_0x3a961e['process'])==null?void 0x0:_0x3e9195['env'])==null?void 0x0:_0x15e8ee[_0x16cf1b(0xd9)])==='edge';(_0x88bcb3===_0x16cf1b(0x127)||_0x88bcb3===_0x16cf1b(0x103)||_0x88bcb3==='astro'||_0x88bcb3===_0x16cf1b(0xf2))&&(_0x88bcb3+=_0x34dcff?_0x16cf1b(0x185):_0x16cf1b(0xe6));let _0x109328='';_0x88bcb3===_0x16cf1b(0x116)&&(_0x109328=(((_0x4c4ef2=(_0x439ee7=(_0x10a097=_0x3a961e[_0x16cf1b(0x153)])==null?void 0x0:_0x10a097[_0x16cf1b(0x1c9)])==null?void 0x0:_0x439ee7[_0x16cf1b(0x100)])==null?void 0x0:_0x4c4ef2['osName'])||_0x16cf1b(0x1b2))['toLowerCase'](),_0x109328&&(_0x88bcb3+='\\x20'+_0x109328,(_0x109328==='android'||_0x109328==='emulator'&&((_0x4624e9=_0x3a961e['location'])==null?void 0x0:_0x4624e9[_0x16cf1b(0xeb)])===_0x16cf1b(0x1d3))&&(_0xd078b1='10.0.2.2'))),_0x3a961e[_0x16cf1b(0x134)]={'id':+new Date(),'tool':_0x88bcb3},_0x22a86b&&_0x88bcb3&&!_0x34dcff&&(_0x109328?console[_0x16cf1b(0x180)](_0x16cf1b(0x1c0)+_0x109328+_0x16cf1b(0x1b4)):console[_0x16cf1b(0x180)](_0x16cf1b(0x114)+(_0x88bcb3['charAt'](0x0)[_0x16cf1b(0x135)]()+_0x88bcb3[_0x16cf1b(0x156)](0x1))+',',_0x16cf1b(0x199),_0x16cf1b(0xe1)));}let _0x42f32c=new z(_0x3a961e,_0xd078b1,_0x21044f,_0x53bf17,_0x4f92ce,_0x4a7f1a);return _0x42f32c[_0x16cf1b(0x133)][_0x16cf1b(0x1ae)](_0x42f32c);}catch(_0x47bf1d){return console[_0x16cf1b(0x12f)](_0x16cf1b(0x142),_0x47bf1d&&_0x47bf1d[_0x16cf1b(0x196)]),()=>{};}});return _0x4da00a=>_0x459821[_0x1231a7(0x11c)](_0x1dd12d=>_0x1dd12d(_0x4da00a));}function _0x482f(_0x245cd1,_0x1857ad){var _0x5eac6f=_0x5eac();return _0x482f=function(_0x482f5b,_0x5dc891){_0x482f5b=_0x482f5b-0xd1;var _0x301275=_0x5eac6f[_0x482f5b];return _0x301275;},_0x482f(_0x245cd1,_0x1857ad);}function ne(_0x596470,_0x6d2e89,_0x5e972c,_0x1d4c9a){var _0x4c2fdb=_0x13c709;_0x1d4c9a&&_0x596470==='reload'&&_0x5e972c[_0x4c2fdb(0x19c)][_0x4c2fdb(0xd8)]();}function b(_0x449572){var _0x323526=_0x13c709,_0x2d47ea,_0x9250b7;let _0x515953=function(_0x52d4ac,_0x4e3247){return _0x4e3247-_0x52d4ac;},_0x37844c;if(_0x449572[_0x323526(0x123)])_0x37844c=function(){var _0x4a2781=_0x323526;return _0x449572[_0x4a2781(0x123)][_0x4a2781(0x144)]();};else{if(_0x449572[_0x323526(0x1a0)]&&_0x449572['process'][_0x323526(0x1ab)]&&((_0x9250b7=(_0x2d47ea=_0x449572[_0x323526(0x1a0)])==null?void 0x0:_0x2d47ea[_0x323526(0x182)])==null?void 0x0:_0x9250b7[_0x323526(0xd9)])!==_0x323526(0x12e))_0x37844c=function(){var _0x595b24=_0x323526;return _0x449572['process'][_0x595b24(0x1ab)]();},_0x515953=function(_0x12de23,_0x38eb40){return 0x3e8*(_0x38eb40[0x0]-_0x12de23[0x0])+(_0x38eb40[0x1]-_0x12de23[0x1])/0xf4240;};else try{let {performance:_0x249599}=require(_0x323526(0xde));_0x37844c=function(){var _0x25bd73=_0x323526;return _0x249599[_0x25bd73(0x144)]();};}catch{_0x37844c=function(){return+new Date();};}}return{'elapsed':_0x515953,'timeStamp':_0x37844c,'now':()=>Date[_0x323526(0x144)]()};}function X(_0x2cb587,_0x7323b0,_0x2aee2b){var _0x4818a3=_0x13c709,_0x2edd26,_0x3c6ebb,_0x60565b,_0x4d69c1,_0xe37c38,_0x19c025,_0x52912f;if(_0x2cb587[_0x4818a3(0x17a)]!==void 0x0)return _0x2cb587[_0x4818a3(0x17a)];let _0x5053c9=((_0x3c6ebb=(_0x2edd26=_0x2cb587[_0x4818a3(0x1a0)])==null?void 0x0:_0x2edd26[_0x4818a3(0x125)])==null?void 0x0:_0x3c6ebb[_0x4818a3(0x190)])||((_0x4d69c1=(_0x60565b=_0x2cb587[_0x4818a3(0x1a0)])==null?void 0x0:_0x60565b[_0x4818a3(0x182)])==null?void 0x0:_0x4d69c1[_0x4818a3(0xd9)])===_0x4818a3(0x12e),_0x1190c9=!!(_0x2aee2b===_0x4818a3(0x116)&&((_0xe37c38=_0x2cb587['expo'])==null?void 0x0:_0xe37c38[_0x4818a3(0x1c9)]));function _0x5a44e6(_0x2958e3){var _0xab6b1=_0x4818a3;if(_0x2958e3['startsWith']('/')&&_0x2958e3[_0xab6b1(0x161)]('/')){let _0x505a38=new RegExp(_0x2958e3[_0xab6b1(0x117)](0x1,-0x1));return _0x34ae10=>_0x505a38[_0xab6b1(0x105)](_0x34ae10);}else{if(_0x2958e3['includes']('*')||_0x2958e3['includes']('?')){let _0x16ce6c=new RegExp('^'+_0x2958e3[_0xab6b1(0x147)](/\\./g,String[_0xab6b1(0x1b3)](0x5c)+'.')[_0xab6b1(0x147)](/\\*/g,'.*')[_0xab6b1(0x147)](/\\?/g,'.')+String[_0xab6b1(0x1b3)](0x24));return _0x50bc0e=>_0x16ce6c[_0xab6b1(0x105)](_0x50bc0e);}else return _0x5965c8=>_0x5965c8===_0x2958e3;}}let _0x5f193c=_0x7323b0[_0x4818a3(0x107)](_0x5a44e6);return _0x2cb587[_0x4818a3(0x17a)]=_0x5053c9||!_0x7323b0,!_0x2cb587[_0x4818a3(0x17a)]&&((_0x19c025=_0x2cb587['location'])==null?void 0x0:_0x19c025['hostname'])&&(_0x2cb587['_consoleNinjaAllowedToStart']=_0x5f193c[_0x4818a3(0x1d8)](_0xb0e6fa=>_0xb0e6fa(_0x2cb587[_0x4818a3(0x19c)][_0x4818a3(0xeb)]))),_0x1190c9&&!_0x2cb587[_0x4818a3(0x17a)]&&!((_0x52912f=_0x2cb587[_0x4818a3(0x19c)])!=null&&_0x52912f[_0x4818a3(0xeb)])&&(_0x2cb587['_consoleNinjaAllowedToStart']=!0x0),_0x2cb587['_consoleNinjaAllowedToStart'];}function J(_0x98598,_0x5dde7d,_0x389014,_0x2c984f,_0x226758,_0x884316){var _0x46c030=_0x13c709;_0x98598=_0x98598,_0x5dde7d=_0x5dde7d,_0x389014=_0x389014,_0x2c984f=_0x2c984f,_0x226758=_0x226758,_0x226758=_0x226758||{},_0x226758[_0x46c030(0xf5)]=_0x226758[_0x46c030(0xf5)]||{},_0x226758[_0x46c030(0x164)]=_0x226758[_0x46c030(0x164)]||{},_0x226758[_0x46c030(0xd4)]=_0x226758[_0x46c030(0xd4)]||{},_0x226758['reducePolicy']['perLogpoint']=_0x226758[_0x46c030(0xd4)]['perLogpoint']||{},_0x226758[_0x46c030(0xd4)]['global']=_0x226758['reducePolicy']['global']||{};let _0x52aa97={'perLogpoint':{'reduceOnCount':_0x226758[_0x46c030(0xd4)]['perLogpoint'][_0x46c030(0x19f)]||0x32,'reduceOnAccumulatedProcessingTimeMs':_0x226758['reducePolicy']['perLogpoint'][_0x46c030(0x1c5)]||0x64,'resetWhenQuietMs':_0x226758[_0x46c030(0xd4)][_0x46c030(0x120)]['resetWhenQuietMs']||0x1f4,'resetOnProcessingTimeAverageMs':_0x226758[_0x46c030(0xd4)][_0x46c030(0x120)]['resetOnProcessingTimeAverageMs']||0x64},'global':{'reduceOnCount':_0x226758[_0x46c030(0xd4)][_0x46c030(0x175)][_0x46c030(0x19f)]||0x3e8,'reduceOnAccumulatedProcessingTimeMs':_0x226758['reducePolicy'][_0x46c030(0x175)][_0x46c030(0x1c5)]||0x12c,'resetWhenQuietMs':_0x226758[_0x46c030(0xd4)][_0x46c030(0x175)]['resetWhenQuietMs']||0x32,'resetOnProcessingTimeAverageMs':_0x226758['reducePolicy']['global'][_0x46c030(0x17d)]||0x64}},_0x1269d4=b(_0x98598),_0x48e275=_0x1269d4[_0x46c030(0xe7)],_0x217603=_0x1269d4['timeStamp'];function _0x27f166(){var _0x527a60=_0x46c030;this[_0x527a60(0x126)]=/^(?!(?:do|if|in|for|let|new|try|var|case|else|enum|eval|false|null|this|true|void|with|break|catch|class|const|super|throw|while|yield|delete|export|import|public|return|static|switch|typeof|default|extends|finally|package|private|continue|debugger|function|arguments|interface|protected|implements|instanceof)$)[_$a-zA-Z\\xA0-\\uFFFF][_$a-zA-Z0-9\\xA0-\\uFFFF]*$/,this[_0x527a60(0x152)]=/^(0|[1-9][0-9]*)$/,this[_0x527a60(0x1a7)]=/'([^\\\\']|\\\\')*'/,this[_0x527a60(0x140)]=_0x98598[_0x527a60(0xf8)],this[_0x527a60(0x1a8)]=_0x98598[_0x527a60(0x1cd)],this[_0x527a60(0x143)]=Object[_0x527a60(0x1b9)],this['_getOwnPropertyNames']=Object[_0x527a60(0x183)],this[_0x527a60(0x158)]=_0x98598[_0x527a60(0x18b)],this[_0x527a60(0x17e)]=RegExp[_0x527a60(0xec)][_0x527a60(0xd5)],this[_0x527a60(0xe5)]=Date[_0x527a60(0xec)][_0x527a60(0xd5)];}_0x27f166['prototype'][_0x46c030(0x14e)]=function(_0x2ecba7,_0x264b74,_0x25b919,_0x5a838a){var _0x17d5dd=_0x46c030,_0x12a3ad=this,_0xe6eae4=_0x25b919[_0x17d5dd(0x13a)];function _0x6e95f(_0x5e7759,_0xec67d4,_0x50346e){var _0x4d161c=_0x17d5dd;_0xec67d4['type']=_0x4d161c(0x1c7),_0xec67d4[_0x4d161c(0x176)]=_0x5e7759[_0x4d161c(0x196)],_0x59f6df=_0x50346e['node'][_0x4d161c(0xf0)],_0x50346e[_0x4d161c(0x190)][_0x4d161c(0xf0)]=_0xec67d4,_0x12a3ad[_0x4d161c(0x1b6)](_0xec67d4,_0x50346e);}let _0x594ddc,_0x3584ca,_0xc4a606=_0x98598[_0x17d5dd(0xe0)];_0x98598[_0x17d5dd(0xe0)]=!0x0,_0x98598['console']&&(_0x594ddc=_0x98598[_0x17d5dd(0x131)][_0x17d5dd(0x176)],_0x3584ca=_0x98598[_0x17d5dd(0x131)][_0x17d5dd(0x12f)],_0x594ddc&&(_0x98598['console']['error']=function(){}),_0x3584ca&&(_0x98598[_0x17d5dd(0x131)][_0x17d5dd(0x12f)]=function(){}));try{try{_0x25b919[_0x17d5dd(0x173)]++,_0x25b919['autoExpand']&&_0x25b919[_0x17d5dd(0x1a5)][_0x17d5dd(0x1b7)](_0x264b74);var _0x213875,_0x5151c2,_0x5b9a4b,_0x5d16ca,_0x6d7db3=[],_0x53ee13=[],_0x396d8f,_0x4d406d=this[_0x17d5dd(0x122)](_0x264b74),_0x411344=_0x4d406d==='array',_0x5bfe1b=!0x1,_0x312215=_0x4d406d===_0x17d5dd(0x12d),_0x475052=this[_0x17d5dd(0x1d7)](_0x4d406d),_0x494045=this[_0x17d5dd(0xfb)](_0x4d406d),_0x1081bf=_0x475052||_0x494045,_0x3f3c3e={},_0x22ace3=0x0,_0x30b096=!0x1,_0x59f6df,_0x370389=/^(([1-9]{1}[0-9]*)|0)$/;if(_0x25b919[_0x17d5dd(0xef)]){if(_0x411344){if(_0x5151c2=_0x264b74[_0x17d5dd(0x184)],_0x5151c2>_0x25b919[_0x17d5dd(0x17c)]){for(_0x5b9a4b=0x0,_0x5d16ca=_0x25b919[_0x17d5dd(0x17c)],_0x213875=_0x5b9a4b;_0x213875<_0x5d16ca;_0x213875++)_0x53ee13[_0x17d5dd(0x1b7)](_0x12a3ad[_0x17d5dd(0xf3)](_0x6d7db3,_0x264b74,_0x4d406d,_0x213875,_0x25b919));_0x2ecba7[_0x17d5dd(0xed)]=!0x0;}else{for(_0x5b9a4b=0x0,_0x5d16ca=_0x5151c2,_0x213875=_0x5b9a4b;_0x213875<_0x5d16ca;_0x213875++)_0x53ee13[_0x17d5dd(0x1b7)](_0x12a3ad['_addProperty'](_0x6d7db3,_0x264b74,_0x4d406d,_0x213875,_0x25b919));}_0x25b919[_0x17d5dd(0x148)]+=_0x53ee13[_0x17d5dd(0x184)];}if(!(_0x4d406d===_0x17d5dd(0xe8)||_0x4d406d===_0x17d5dd(0xf8))&&!_0x475052&&_0x4d406d!==_0x17d5dd(0x124)&&_0x4d406d!==_0x17d5dd(0x11f)&&_0x4d406d!==_0x17d5dd(0x17f)){var _0xde9af5=_0x5a838a[_0x17d5dd(0x14b)]||_0x25b919['props'];if(this['_isSet'](_0x264b74)?(_0x213875=0x0,_0x264b74['forEach'](function(_0x5154b3){var _0x4f232e=_0x17d5dd;if(_0x22ace3++,_0x25b919[_0x4f232e(0x148)]++,_0x22ace3>_0xde9af5){_0x30b096=!0x0;return;}if(!_0x25b919[_0x4f232e(0xdd)]&&_0x25b919[_0x4f232e(0x13a)]&&_0x25b919[_0x4f232e(0x148)]>_0x25b919['autoExpandLimit']){_0x30b096=!0x0;return;}_0x53ee13[_0x4f232e(0x1b7)](_0x12a3ad['_addProperty'](_0x6d7db3,_0x264b74,_0x4f232e(0x1bb),_0x213875++,_0x25b919,function(_0x110f5b){return function(){return _0x110f5b;};}(_0x5154b3)));})):this[_0x17d5dd(0xea)](_0x264b74)&&_0x264b74[_0x17d5dd(0x11c)](function(_0x23e56a,_0x2296b){var _0x49f001=_0x17d5dd;if(_0x22ace3++,_0x25b919['autoExpandPropertyCount']++,_0x22ace3>_0xde9af5){_0x30b096=!0x0;return;}if(!_0x25b919[_0x49f001(0xdd)]&&_0x25b919[_0x49f001(0x13a)]&&_0x25b919[_0x49f001(0x148)]>_0x25b919['autoExpandLimit']){_0x30b096=!0x0;return;}var _0x3a32d2=_0x2296b[_0x49f001(0xd5)]();_0x3a32d2['length']>0x64&&(_0x3a32d2=_0x3a32d2[_0x49f001(0x117)](0x0,0x64)+'...'),_0x53ee13[_0x49f001(0x1b7)](_0x12a3ad[_0x49f001(0xf3)](_0x6d7db3,_0x264b74,'Map',_0x3a32d2,_0x25b919,function(_0x3e1afc){return function(){return _0x3e1afc;};}(_0x23e56a)));}),!_0x5bfe1b){try{for(_0x396d8f in _0x264b74)if(!(_0x411344&&_0x370389[_0x17d5dd(0x105)](_0x396d8f))&&!this[_0x17d5dd(0x10b)](_0x264b74,_0x396d8f,_0x25b919)){if(_0x22ace3++,_0x25b919['autoExpandPropertyCount']++,_0x22ace3>_0xde9af5){_0x30b096=!0x0;break;}if(!_0x25b919[_0x17d5dd(0xdd)]&&_0x25b919[_0x17d5dd(0x13a)]&&_0x25b919[_0x17d5dd(0x148)]>_0x25b919[_0x17d5dd(0x174)]){_0x30b096=!0x0;break;}_0x53ee13[_0x17d5dd(0x1b7)](_0x12a3ad[_0x17d5dd(0x187)](_0x6d7db3,_0x3f3c3e,_0x264b74,_0x4d406d,_0x396d8f,_0x25b919));}}catch{}if(_0x3f3c3e[_0x17d5dd(0x1b1)]=!0x0,_0x312215&&(_0x3f3c3e[_0x17d5dd(0x188)]=!0x0),!_0x30b096){var _0x236944=[]['concat'](this[_0x17d5dd(0x112)](_0x264b74))[_0x17d5dd(0x1a2)](this['_getOwnPropertySymbols'](_0x264b74));for(_0x213875=0x0,_0x5151c2=_0x236944[_0x17d5dd(0x184)];_0x213875<_0x5151c2;_0x213875++)if(_0x396d8f=_0x236944[_0x213875],!(_0x411344&&_0x370389[_0x17d5dd(0x105)](_0x396d8f['toString']()))&&!this['_blacklistedProperty'](_0x264b74,_0x396d8f,_0x25b919)&&!_0x3f3c3e[typeof _0x396d8f!=_0x17d5dd(0x13e)?_0x17d5dd(0x1bd)+_0x396d8f['toString']():_0x396d8f]){if(_0x22ace3++,_0x25b919[_0x17d5dd(0x148)]++,_0x22ace3>_0xde9af5){_0x30b096=!0x0;break;}if(!_0x25b919[_0x17d5dd(0xdd)]&&_0x25b919['autoExpand']&&_0x25b919[_0x17d5dd(0x148)]>_0x25b919[_0x17d5dd(0x174)]){_0x30b096=!0x0;break;}_0x53ee13['push'](_0x12a3ad[_0x17d5dd(0x187)](_0x6d7db3,_0x3f3c3e,_0x264b74,_0x4d406d,_0x396d8f,_0x25b919));}}}}}if(_0x2ecba7['type']=_0x4d406d,_0x1081bf?(_0x2ecba7['value']=_0x264b74[_0x17d5dd(0x132)](),this[_0x17d5dd(0x11a)](_0x4d406d,_0x2ecba7,_0x25b919,_0x5a838a)):_0x4d406d==='date'?_0x2ecba7[_0x17d5dd(0x1ca)]=this[_0x17d5dd(0xe5)][_0x17d5dd(0x1c1)](_0x264b74):_0x4d406d===_0x17d5dd(0x17f)?_0x2ecba7[_0x17d5dd(0x1ca)]=_0x264b74[_0x17d5dd(0xd5)]():_0x4d406d==='RegExp'?_0x2ecba7[_0x17d5dd(0x1ca)]=this[_0x17d5dd(0x17e)][_0x17d5dd(0x1c1)](_0x264b74):_0x4d406d===_0x17d5dd(0x13e)&&this[_0x17d5dd(0x158)]?_0x2ecba7['value']=this[_0x17d5dd(0x158)][_0x17d5dd(0xec)][_0x17d5dd(0xd5)][_0x17d5dd(0x1c1)](_0x264b74):!_0x25b919[_0x17d5dd(0xef)]&&!(_0x4d406d===_0x17d5dd(0xe8)||_0x4d406d===_0x17d5dd(0xf8))&&(delete _0x2ecba7[_0x17d5dd(0x1ca)],_0x2ecba7[_0x17d5dd(0xf4)]=!0x0),_0x30b096&&(_0x2ecba7[_0x17d5dd(0x10f)]=!0x0),_0x59f6df=_0x25b919[_0x17d5dd(0x190)][_0x17d5dd(0xf0)],_0x25b919[_0x17d5dd(0x190)][_0x17d5dd(0xf0)]=_0x2ecba7,this[_0x17d5dd(0x1b6)](_0x2ecba7,_0x25b919),_0x53ee13[_0x17d5dd(0x184)]){for(_0x213875=0x0,_0x5151c2=_0x53ee13[_0x17d5dd(0x184)];_0x213875<_0x5151c2;_0x213875++)_0x53ee13[_0x213875](_0x213875);}_0x6d7db3[_0x17d5dd(0x184)]&&(_0x2ecba7[_0x17d5dd(0x14b)]=_0x6d7db3);}catch(_0x8d5f04){_0x6e95f(_0x8d5f04,_0x2ecba7,_0x25b919);}this['_additionalMetadata'](_0x264b74,_0x2ecba7),this[_0x17d5dd(0x15a)](_0x2ecba7,_0x25b919),_0x25b919[_0x17d5dd(0x190)][_0x17d5dd(0xf0)]=_0x59f6df,_0x25b919[_0x17d5dd(0x173)]--,_0x25b919[_0x17d5dd(0x13a)]=_0xe6eae4,_0x25b919[_0x17d5dd(0x13a)]&&_0x25b919[_0x17d5dd(0x1a5)][_0x17d5dd(0x1d9)]();}finally{_0x594ddc&&(_0x98598[_0x17d5dd(0x131)][_0x17d5dd(0x176)]=_0x594ddc),_0x3584ca&&(_0x98598[_0x17d5dd(0x131)][_0x17d5dd(0x12f)]=_0x3584ca),_0x98598['ninjaSuppressConsole']=_0xc4a606;}return _0x2ecba7;},_0x27f166[_0x46c030(0xec)][_0x46c030(0x1cf)]=function(_0x2c558e){var _0x148c3e=_0x46c030;return Object[_0x148c3e(0x118)]?Object[_0x148c3e(0x118)](_0x2c558e):[];},_0x27f166[_0x46c030(0xec)][_0x46c030(0x121)]=function(_0x5c66a1){var _0x540e12=_0x46c030;return!!(_0x5c66a1&&_0x98598['Set']&&this[_0x540e12(0x1bc)](_0x5c66a1)==='[object\\x20Set]'&&_0x5c66a1[_0x540e12(0x11c)]);},_0x27f166['prototype']['_blacklistedProperty']=function(_0x409b27,_0x8094e5,_0x119d1b){var _0x599c10=_0x46c030;if(!_0x119d1b[_0x599c10(0x137)]){let _0x47a692=this['_getOwnPropertyDescriptor'](_0x409b27,_0x8094e5);if(_0x47a692&&_0x47a692[_0x599c10(0x154)])return!0x0;}return _0x119d1b[_0x599c10(0x1be)]?typeof _0x409b27[_0x8094e5]==_0x599c10(0x12d):!0x1;},_0x27f166[_0x46c030(0xec)][_0x46c030(0x122)]=function(_0x49dbc6){var _0xb232ad=_0x46c030,_0x48bac9='';return _0x48bac9=typeof _0x49dbc6,_0x48bac9===_0xb232ad(0x111)?this[_0xb232ad(0x1bc)](_0x49dbc6)===_0xb232ad(0x171)?_0x48bac9=_0xb232ad(0x19e):this[_0xb232ad(0x1bc)](_0x49dbc6)==='[object\\x20Date]'?_0x48bac9=_0xb232ad(0x1ac):this[_0xb232ad(0x1bc)](_0x49dbc6)==='[object\\x20BigInt]'?_0x48bac9='bigint':_0x49dbc6===null?_0x48bac9='null':_0x49dbc6[_0xb232ad(0x18c)]&&(_0x48bac9=_0x49dbc6[_0xb232ad(0x18c)]['name']||_0x48bac9):_0x48bac9===_0xb232ad(0xf8)&&this['_HTMLAllCollection']&&_0x49dbc6 instanceof this[_0xb232ad(0x1a8)]&&(_0x48bac9='HTMLAllCollection'),_0x48bac9;},_0x27f166[_0x46c030(0xec)]['_objectToString']=function(_0xdf7e0a){var _0x37d846=_0x46c030;return Object[_0x37d846(0xec)][_0x37d846(0xd5)][_0x37d846(0x1c1)](_0xdf7e0a);},_0x27f166['prototype'][_0x46c030(0x1d7)]=function(_0x3db124){var _0x57c02a=_0x46c030;return _0x3db124===_0x57c02a(0x163)||_0x3db124===_0x57c02a(0x101)||_0x3db124===_0x57c02a(0x1a6);},_0x27f166[_0x46c030(0xec)]['_isPrimitiveWrapperType']=function(_0x387647){var _0xe666dc=_0x46c030;return _0x387647===_0xe666dc(0x15b)||_0x387647===_0xe666dc(0x124)||_0x387647===_0xe666dc(0x179);},_0x27f166[_0x46c030(0xec)][_0x46c030(0xf3)]=function(_0x226d6c,_0x319c6f,_0x1e3daa,_0x3cb8b7,_0x3d1374,_0x1afdcc){var _0x50c922=this;return function(_0x36768a){var _0x1416a6=_0x482f,_0x471b5b=_0x3d1374[_0x1416a6(0x190)][_0x1416a6(0xf0)],_0x742136=_0x3d1374[_0x1416a6(0x190)][_0x1416a6(0x170)],_0x1a290c=_0x3d1374[_0x1416a6(0x190)][_0x1416a6(0x177)];_0x3d1374[_0x1416a6(0x190)][_0x1416a6(0x177)]=_0x471b5b,_0x3d1374[_0x1416a6(0x190)][_0x1416a6(0x170)]=typeof _0x3cb8b7==_0x1416a6(0x1a6)?_0x3cb8b7:_0x36768a,_0x226d6c[_0x1416a6(0x1b7)](_0x50c922[_0x1416a6(0x110)](_0x319c6f,_0x1e3daa,_0x3cb8b7,_0x3d1374,_0x1afdcc)),_0x3d1374[_0x1416a6(0x190)][_0x1416a6(0x177)]=_0x1a290c,_0x3d1374[_0x1416a6(0x190)][_0x1416a6(0x170)]=_0x742136;};},_0x27f166[_0x46c030(0xec)][_0x46c030(0x187)]=function(_0x118818,_0x46243a,_0x378e01,_0x157ae4,_0x4fb345,_0x10973c,_0x2e5a84){var _0x3d8357=_0x46c030,_0x1d6c4a=this;return _0x46243a[typeof _0x4fb345!=_0x3d8357(0x13e)?_0x3d8357(0x1bd)+_0x4fb345[_0x3d8357(0xd5)]():_0x4fb345]=!0x0,function(_0x4b5166){var _0xf96915=_0x3d8357,_0x216af2=_0x10973c[_0xf96915(0x190)]['current'],_0x5f5a11=_0x10973c['node'][_0xf96915(0x170)],_0x5bfbbe=_0x10973c[_0xf96915(0x190)][_0xf96915(0x177)];_0x10973c[_0xf96915(0x190)][_0xf96915(0x177)]=_0x216af2,_0x10973c['node'][_0xf96915(0x170)]=_0x4b5166,_0x118818[_0xf96915(0x1b7)](_0x1d6c4a[_0xf96915(0x110)](_0x378e01,_0x157ae4,_0x4fb345,_0x10973c,_0x2e5a84)),_0x10973c[_0xf96915(0x190)][_0xf96915(0x177)]=_0x5bfbbe,_0x10973c[_0xf96915(0x190)][_0xf96915(0x170)]=_0x5f5a11;};},_0x27f166['prototype'][_0x46c030(0x110)]=function(_0x55703c,_0x4fb4e0,_0x2ff1ad,_0x4f9a86,_0x3b9c51){var _0x346ba8=_0x46c030,_0x4d5331=this;_0x3b9c51||(_0x3b9c51=function(_0x346753,_0x4426cc){return _0x346753[_0x4426cc];});var _0x2b6f0c=_0x2ff1ad[_0x346ba8(0xd5)](),_0x28a10e=_0x4f9a86[_0x346ba8(0x10e)]||{},_0x3113f7=_0x4f9a86[_0x346ba8(0xef)],_0x1fadb7=_0x4f9a86[_0x346ba8(0xdd)];try{var _0x41c5df=this[_0x346ba8(0xea)](_0x55703c),_0x4d70b1=_0x2b6f0c;_0x41c5df&&_0x4d70b1[0x0]==='\\x27'&&(_0x4d70b1=_0x4d70b1['substr'](0x1,_0x4d70b1[_0x346ba8(0x184)]-0x2));var _0x572955=_0x4f9a86['expressionsToEvaluate']=_0x28a10e[_0x346ba8(0x1bd)+_0x4d70b1];_0x572955&&(_0x4f9a86[_0x346ba8(0xef)]=_0x4f9a86['depth']+0x1),_0x4f9a86[_0x346ba8(0xdd)]=!!_0x572955;var _0x1a01b3=typeof _0x2ff1ad==_0x346ba8(0x13e),_0x2bdc16={'name':_0x1a01b3||_0x41c5df?_0x2b6f0c:this[_0x346ba8(0xdc)](_0x2b6f0c)};if(_0x1a01b3&&(_0x2bdc16[_0x346ba8(0x13e)]=!0x0),!(_0x4fb4e0===_0x346ba8(0x19e)||_0x4fb4e0===_0x346ba8(0x197))){var _0x116684=this['_getOwnPropertyDescriptor'](_0x55703c,_0x2ff1ad);if(_0x116684&&(_0x116684[_0x346ba8(0xe2)]&&(_0x2bdc16[_0x346ba8(0x14a)]=!0x0),_0x116684[_0x346ba8(0x154)]&&!_0x572955&&!_0x4f9a86[_0x346ba8(0x137)]))return _0x2bdc16[_0x346ba8(0x11b)]=!0x0,this[_0x346ba8(0x13f)](_0x2bdc16,_0x4f9a86),_0x2bdc16;}var _0x4249b;try{_0x4249b=_0x3b9c51(_0x55703c,_0x2ff1ad);}catch(_0x58b047){return _0x2bdc16={'name':_0x2b6f0c,'type':_0x346ba8(0x1c7),'error':_0x58b047['message']},this['_processTreeNodeResult'](_0x2bdc16,_0x4f9a86),_0x2bdc16;}var _0x177c2f=this['_type'](_0x4249b),_0x12a734=this['_isPrimitiveType'](_0x177c2f);if(_0x2bdc16[_0x346ba8(0x16d)]=_0x177c2f,_0x12a734)this[_0x346ba8(0x13f)](_0x2bdc16,_0x4f9a86,_0x4249b,function(){var _0x1aab58=_0x346ba8;_0x2bdc16[_0x1aab58(0x1ca)]=_0x4249b[_0x1aab58(0x132)](),!_0x572955&&_0x4d5331[_0x1aab58(0x11a)](_0x177c2f,_0x2bdc16,_0x4f9a86,{});});else{var _0x133e9e=_0x4f9a86[_0x346ba8(0x13a)]&&_0x4f9a86[_0x346ba8(0x173)]<_0x4f9a86[_0x346ba8(0x104)]&&_0x4f9a86[_0x346ba8(0x1a5)][_0x346ba8(0x149)](_0x4249b)<0x0&&_0x177c2f!=='function'&&_0x4f9a86['autoExpandPropertyCount']<_0x4f9a86[_0x346ba8(0x174)];_0x133e9e||_0x4f9a86[_0x346ba8(0x173)]<_0x3113f7||_0x572955?this[_0x346ba8(0x14e)](_0x2bdc16,_0x4249b,_0x4f9a86,_0x572955||{}):this['_processTreeNodeResult'](_0x2bdc16,_0x4f9a86,_0x4249b,function(){var _0x5f0099=_0x346ba8;_0x177c2f===_0x5f0099(0xe8)||_0x177c2f===_0x5f0099(0xf8)||(delete _0x2bdc16[_0x5f0099(0x1ca)],_0x2bdc16[_0x5f0099(0xf4)]=!0x0);});}return _0x2bdc16;}finally{_0x4f9a86[_0x346ba8(0x10e)]=_0x28a10e,_0x4f9a86['depth']=_0x3113f7,_0x4f9a86[_0x346ba8(0xdd)]=_0x1fadb7;}},_0x27f166[_0x46c030(0xec)][_0x46c030(0x11a)]=function(_0x131e92,_0x52281b,_0x2538b0,_0x17f9be){var _0x49a636=_0x46c030,_0xf6386c=_0x17f9be[_0x49a636(0x1c6)]||_0x2538b0[_0x49a636(0x1c6)];if((_0x131e92==='string'||_0x131e92===_0x49a636(0x124))&&_0x52281b[_0x49a636(0x1ca)]){let _0x532995=_0x52281b[_0x49a636(0x1ca)][_0x49a636(0x184)];_0x2538b0[_0x49a636(0x198)]+=_0x532995,_0x2538b0['allStrLength']>_0x2538b0[_0x49a636(0x18f)]?(_0x52281b[_0x49a636(0xf4)]='',delete _0x52281b[_0x49a636(0x1ca)]):_0x532995>_0xf6386c&&(_0x52281b[_0x49a636(0xf4)]=_0x52281b[_0x49a636(0x1ca)]['substr'](0x0,_0xf6386c),delete _0x52281b[_0x49a636(0x1ca)]);}},_0x27f166['prototype'][_0x46c030(0xea)]=function(_0x1e2506){var _0x384e85=_0x46c030;return!!(_0x1e2506&&_0x98598[_0x384e85(0x150)]&&this[_0x384e85(0x1bc)](_0x1e2506)===_0x384e85(0x1a9)&&_0x1e2506[_0x384e85(0x11c)]);},_0x27f166[_0x46c030(0xec)][_0x46c030(0xdc)]=function(_0x21e8cb){var _0x1d6332=_0x46c030;if(_0x21e8cb[_0x1d6332(0x10d)](/^\\d+$/))return _0x21e8cb;var _0x1b719c;try{_0x1b719c=JSON[_0x1d6332(0x191)](''+_0x21e8cb);}catch{_0x1b719c='\\x22'+this[_0x1d6332(0x1bc)](_0x21e8cb)+'\\x22';}return _0x1b719c[_0x1d6332(0x10d)](/^\"([a-zA-Z_][a-zA-Z_0-9]*)\"$/)?_0x1b719c=_0x1b719c[_0x1d6332(0x156)](0x1,_0x1b719c['length']-0x2):_0x1b719c=_0x1b719c[_0x1d6332(0x147)](/'/g,'\\x5c\\x27')['replace'](/\\\\\"/g,'\\x22')[_0x1d6332(0x147)](/(^\"|\"$)/g,'\\x27'),_0x1b719c;},_0x27f166[_0x46c030(0xec)][_0x46c030(0x13f)]=function(_0x3fd9ce,_0x1c8174,_0x390c75,_0x1a6f9b){var _0x207d36=_0x46c030;this[_0x207d36(0x1b6)](_0x3fd9ce,_0x1c8174),_0x1a6f9b&&_0x1a6f9b(),this['_additionalMetadata'](_0x390c75,_0x3fd9ce),this[_0x207d36(0x15a)](_0x3fd9ce,_0x1c8174);},_0x27f166[_0x46c030(0xec)][_0x46c030(0x1b6)]=function(_0x4eb64c,_0xbd62f8){var _0x572dfb=_0x46c030;this[_0x572dfb(0x178)](_0x4eb64c,_0xbd62f8),this[_0x572dfb(0x1aa)](_0x4eb64c,_0xbd62f8),this[_0x572dfb(0xda)](_0x4eb64c,_0xbd62f8),this[_0x572dfb(0x1cc)](_0x4eb64c,_0xbd62f8);},_0x27f166[_0x46c030(0xec)][_0x46c030(0x178)]=function(_0x14df51,_0x31fe0e){},_0x27f166['prototype'][_0x46c030(0x1aa)]=function(_0x203e3b,_0x40615f){},_0x27f166[_0x46c030(0xec)][_0x46c030(0x18a)]=function(_0x304d74,_0x1cfe2a){},_0x27f166[_0x46c030(0xec)]['_isUndefined']=function(_0x1a54ab){var _0x370e8c=_0x46c030;return _0x1a54ab===this[_0x370e8c(0x140)];},_0x27f166[_0x46c030(0xec)][_0x46c030(0x15a)]=function(_0x5811fe,_0x5b7eac){var _0x242559=_0x46c030;this[_0x242559(0x18a)](_0x5811fe,_0x5b7eac),this[_0x242559(0x18e)](_0x5811fe),_0x5b7eac[_0x242559(0x19b)]&&this[_0x242559(0x10a)](_0x5811fe),this[_0x242559(0x16b)](_0x5811fe,_0x5b7eac),this['_addLoadNode'](_0x5811fe,_0x5b7eac),this[_0x242559(0x1cb)](_0x5811fe);},_0x27f166[_0x46c030(0xec)]['_additionalMetadata']=function(_0x1d7d8b,_0x415173){var _0x1fab0b=_0x46c030;try{_0x1d7d8b&&typeof _0x1d7d8b['length']==_0x1fab0b(0x1a6)&&(_0x415173['length']=_0x1d7d8b[_0x1fab0b(0x184)]);}catch{}if(_0x415173[_0x1fab0b(0x16d)]===_0x1fab0b(0x1a6)||_0x415173['type']==='Number'){if(isNaN(_0x415173[_0x1fab0b(0x1ca)]))_0x415173[_0x1fab0b(0x1a3)]=!0x0,delete _0x415173[_0x1fab0b(0x1ca)];else switch(_0x415173[_0x1fab0b(0x1ca)]){case Number['POSITIVE_INFINITY']:_0x415173[_0x1fab0b(0x1b5)]=!0x0,delete _0x415173[_0x1fab0b(0x1ca)];break;case Number[_0x1fab0b(0xdf)]:_0x415173['negativeInfinity']=!0x0,delete _0x415173[_0x1fab0b(0x1ca)];break;case 0x0:this[_0x1fab0b(0xee)](_0x415173[_0x1fab0b(0x1ca)])&&(_0x415173[_0x1fab0b(0x146)]=!0x0);break;}}else _0x415173['type']===_0x1fab0b(0x12d)&&typeof _0x1d7d8b[_0x1fab0b(0x12a)]==_0x1fab0b(0x101)&&_0x1d7d8b[_0x1fab0b(0x12a)]&&_0x415173[_0x1fab0b(0x12a)]&&_0x1d7d8b[_0x1fab0b(0x12a)]!==_0x415173[_0x1fab0b(0x12a)]&&(_0x415173['funcName']=_0x1d7d8b[_0x1fab0b(0x12a)]);},_0x27f166[_0x46c030(0xec)][_0x46c030(0xee)]=function(_0x5cc138){var _0x263249=_0x46c030;return 0x1/_0x5cc138===Number[_0x263249(0xdf)];},_0x27f166['prototype']['_sortProps']=function(_0x557845){var _0x8c3adf=_0x46c030;!_0x557845[_0x8c3adf(0x14b)]||!_0x557845['props']['length']||_0x557845[_0x8c3adf(0x16d)]===_0x8c3adf(0x19e)||_0x557845[_0x8c3adf(0x16d)]==='Map'||_0x557845[_0x8c3adf(0x16d)]==='Set'||_0x557845[_0x8c3adf(0x14b)][_0x8c3adf(0x10c)](function(_0x2373a4,_0x7784e){var _0x40a768=_0x8c3adf,_0x1d4deb=_0x2373a4[_0x40a768(0x12a)][_0x40a768(0x160)](),_0xe59b4f=_0x7784e['name']['toLowerCase']();return _0x1d4deb<_0xe59b4f?-0x1:_0x1d4deb>_0xe59b4f?0x1:0x0;});},_0x27f166['prototype'][_0x46c030(0x16b)]=function(_0x358079,_0x1db5f5){var _0x33a57b=_0x46c030;if(!(_0x1db5f5[_0x33a57b(0x1be)]||!_0x358079[_0x33a57b(0x14b)]||!_0x358079[_0x33a57b(0x14b)][_0x33a57b(0x184)])){for(var _0xade3a3=[],_0x5c90a3=[],_0x1bc1a9=0x0,_0x2897b8=_0x358079[_0x33a57b(0x14b)][_0x33a57b(0x184)];_0x1bc1a9<_0x2897b8;_0x1bc1a9++){var _0xeef903=_0x358079[_0x33a57b(0x14b)][_0x1bc1a9];_0xeef903['type']===_0x33a57b(0x12d)?_0xade3a3['push'](_0xeef903):_0x5c90a3[_0x33a57b(0x1b7)](_0xeef903);}if(!(!_0x5c90a3['length']||_0xade3a3[_0x33a57b(0x184)]<=0x1)){_0x358079[_0x33a57b(0x14b)]=_0x5c90a3;var _0x4b0d24={'functionsNode':!0x0,'props':_0xade3a3};this['_setNodeId'](_0x4b0d24,_0x1db5f5),this[_0x33a57b(0x18a)](_0x4b0d24,_0x1db5f5),this['_setNodeExpandableState'](_0x4b0d24),this['_setNodePermissions'](_0x4b0d24,_0x1db5f5),_0x4b0d24['id']+='\\x20f',_0x358079['props']['unshift'](_0x4b0d24);}}},_0x27f166[_0x46c030(0xec)][_0x46c030(0x168)]=function(_0x4d1f10,_0x38050a){},_0x27f166[_0x46c030(0xec)][_0x46c030(0x18e)]=function(_0x53eae9){},_0x27f166[_0x46c030(0xec)][_0x46c030(0x1ba)]=function(_0x3f1f0b){var _0x5c5e2d=_0x46c030;return Array[_0x5c5e2d(0xdb)](_0x3f1f0b)||typeof _0x3f1f0b==_0x5c5e2d(0x111)&&this[_0x5c5e2d(0x1bc)](_0x3f1f0b)==='[object\\x20Array]';},_0x27f166['prototype'][_0x46c030(0x1cc)]=function(_0x1b6a5b,_0x4f7877){},_0x27f166['prototype'][_0x46c030(0x1cb)]=function(_0x5c0134){var _0x53c547=_0x46c030;delete _0x5c0134['_hasSymbolPropertyOnItsPath'],delete _0x5c0134[_0x53c547(0x195)],delete _0x5c0134[_0x53c547(0x1a4)];},_0x27f166[_0x46c030(0xec)]['_setNodeExpressionPath']=function(_0x3591ef,_0x47f3e8){};let _0x45b2b9=new _0x27f166(),_0x53716e={'props':_0x226758[_0x46c030(0xf5)]['props']||0x64,'elements':_0x226758[_0x46c030(0xf5)]['elements']||0x64,'strLength':_0x226758[_0x46c030(0xf5)][_0x46c030(0x1c6)]||0x400*0x32,'totalStrLength':_0x226758['defaultLimits'][_0x46c030(0x18f)]||0x400*0x32,'autoExpandLimit':_0x226758['defaultLimits'][_0x46c030(0x174)]||0x1388,'autoExpandMaxDepth':_0x226758[_0x46c030(0xf5)][_0x46c030(0x104)]||0xa},_0x2ce2e1={'props':_0x226758['reducedLimits'][_0x46c030(0x14b)]||0x5,'elements':_0x226758['reducedLimits'][_0x46c030(0x17c)]||0x5,'strLength':_0x226758[_0x46c030(0x164)][_0x46c030(0x1c6)]||0x100,'totalStrLength':_0x226758[_0x46c030(0x164)][_0x46c030(0x18f)]||0x100*0x3,'autoExpandLimit':_0x226758[_0x46c030(0x164)][_0x46c030(0x174)]||0x1e,'autoExpandMaxDepth':_0x226758[_0x46c030(0x164)][_0x46c030(0x104)]||0x2};if(_0x884316){let _0x110f3a=_0x45b2b9[_0x46c030(0x14e)][_0x46c030(0x1ae)](_0x45b2b9);_0x45b2b9[_0x46c030(0x14e)]=function(_0x450d0e,_0x104842,_0x6b4429,_0x1c5b64){return _0x110f3a(_0x450d0e,_0x884316(_0x104842),_0x6b4429,_0x1c5b64);};}function _0x24ff86(_0xa63077,_0x33a6c1,_0x2fefb8,_0x4aadfe,_0xa598cd,_0x5d4752){var _0x107197=_0x46c030;let _0x2be5a8,_0x388d9a;try{_0x388d9a=_0x217603(),_0x2be5a8=_0x389014[_0x33a6c1],!_0x2be5a8||_0x388d9a-_0x2be5a8['ts']>_0x52aa97[_0x107197(0x120)][_0x107197(0x15d)]&&_0x2be5a8[_0x107197(0x172)]&&_0x2be5a8[_0x107197(0x167)]/_0x2be5a8[_0x107197(0x172)]<_0x52aa97[_0x107197(0x120)][_0x107197(0x17d)]?(_0x389014[_0x33a6c1]=_0x2be5a8={'count':0x0,'time':0x0,'ts':_0x388d9a},_0x389014[_0x107197(0x15f)]={}):_0x388d9a-_0x389014['hits']['ts']>_0x52aa97[_0x107197(0x175)][_0x107197(0x15d)]&&_0x389014['hits']['count']&&_0x389014[_0x107197(0x15f)][_0x107197(0x167)]/_0x389014[_0x107197(0x15f)][_0x107197(0x172)]<_0x52aa97[_0x107197(0x175)][_0x107197(0x17d)]&&(_0x389014[_0x107197(0x15f)]={});let _0x3222c4=[],_0x506749=_0x2be5a8[_0x107197(0x155)]||_0x389014['hits'][_0x107197(0x155)]?_0x2ce2e1:_0x53716e,_0x4a70b5=_0x14d34c=>{var _0x30ff6f=_0x107197;let _0x415dc7={};return _0x415dc7[_0x30ff6f(0x14b)]=_0x14d34c[_0x30ff6f(0x14b)],_0x415dc7[_0x30ff6f(0x17c)]=_0x14d34c[_0x30ff6f(0x17c)],_0x415dc7[_0x30ff6f(0x1c6)]=_0x14d34c['strLength'],_0x415dc7[_0x30ff6f(0x18f)]=_0x14d34c[_0x30ff6f(0x18f)],_0x415dc7[_0x30ff6f(0x174)]=_0x14d34c[_0x30ff6f(0x174)],_0x415dc7[_0x30ff6f(0x104)]=_0x14d34c[_0x30ff6f(0x104)],_0x415dc7['sortProps']=!0x1,_0x415dc7['noFunctions']=!_0x5dde7d,_0x415dc7[_0x30ff6f(0xef)]=0x1,_0x415dc7[_0x30ff6f(0x173)]=0x0,_0x415dc7[_0x30ff6f(0xfd)]='root_exp_id',_0x415dc7[_0x30ff6f(0xf7)]=_0x30ff6f(0x13d),_0x415dc7[_0x30ff6f(0x13a)]=!0x0,_0x415dc7[_0x30ff6f(0x1a5)]=[],_0x415dc7['autoExpandPropertyCount']=0x0,_0x415dc7['resolveGetters']=_0x226758[_0x30ff6f(0x137)],_0x415dc7[_0x30ff6f(0x198)]=0x0,_0x415dc7[_0x30ff6f(0x190)]={'current':void 0x0,'parent':void 0x0,'index':0x0},_0x415dc7;};for(var _0x1b380b=0x0;_0x1b380b<_0xa598cd[_0x107197(0x184)];_0x1b380b++)_0x3222c4[_0x107197(0x1b7)](_0x45b2b9['serialize']({'timeNode':_0xa63077===_0x107197(0x167)||void 0x0},_0xa598cd[_0x1b380b],_0x4a70b5(_0x506749),{}));if(_0xa63077==='trace'||_0xa63077===_0x107197(0x176)){let _0x22c09e=Error['stackTraceLimit'];try{Error[_0x107197(0xd6)]=0x1/0x0,_0x3222c4[_0x107197(0x1b7)](_0x45b2b9[_0x107197(0x14e)]({'stackNode':!0x0},new Error()[_0x107197(0xe4)],_0x4a70b5(_0x506749),{'strLength':0x1/0x0}));}finally{Error['stackTraceLimit']=_0x22c09e;}}return{'method':_0x107197(0x180),'version':_0x2c984f,'args':[{'ts':_0x2fefb8,'session':_0x4aadfe,'args':_0x3222c4,'id':_0x33a6c1,'context':_0x5d4752}]};}catch(_0x157c27){return{'method':_0x107197(0x180),'version':_0x2c984f,'args':[{'ts':_0x2fefb8,'session':_0x4aadfe,'args':[{'type':_0x107197(0x1c7),'error':_0x157c27&&_0x157c27[_0x107197(0x196)]}],'id':_0x33a6c1,'context':_0x5d4752}]};}finally{try{if(_0x2be5a8&&_0x388d9a){let _0x481412=_0x217603();_0x2be5a8[_0x107197(0x172)]++,_0x2be5a8[_0x107197(0x167)]+=_0x48e275(_0x388d9a,_0x481412),_0x2be5a8['ts']=_0x481412,_0x389014[_0x107197(0x15f)]['count']++,_0x389014[_0x107197(0x15f)][_0x107197(0x167)]+=_0x48e275(_0x388d9a,_0x481412),_0x389014[_0x107197(0x15f)]['ts']=_0x481412,(_0x2be5a8[_0x107197(0x172)]>_0x52aa97['perLogpoint']['reduceOnCount']||_0x2be5a8['time']>_0x52aa97['perLogpoint'][_0x107197(0x1c5)])&&(_0x2be5a8['reduceLimits']=!0x0),(_0x389014[_0x107197(0x15f)]['count']>_0x52aa97[_0x107197(0x175)]['reduceOnCount']||_0x389014[_0x107197(0x15f)][_0x107197(0x167)]>_0x52aa97[_0x107197(0x175)][_0x107197(0x1c5)])&&(_0x389014['hits'][_0x107197(0x155)]=!0x0);}}catch{}}}return _0x24ff86;}function G(_0x51a1e1){var _0x326676=_0x13c709;if(_0x51a1e1&&typeof _0x51a1e1=='object'&&_0x51a1e1[_0x326676(0x18c)])switch(_0x51a1e1['constructor'][_0x326676(0x12a)]){case'Promise':return _0x51a1e1['hasOwnProperty'](Symbol[_0x326676(0x157)])?Promise['resolve']():_0x51a1e1;case _0x326676(0x16e):return Promise['resolve']();}return _0x51a1e1;}((_0x3a2e2f,_0x36d0b8,_0x13c80a,_0x5a69e4,_0x1f9e1f,_0x3db9d2,_0x5656cf,_0x401541,_0x5d73ce,_0x49429e,_0x569f40,_0x4c4a1f)=>{var _0x515b3b=_0x13c709;if(_0x3a2e2f[_0x515b3b(0x159)])return _0x3a2e2f[_0x515b3b(0x159)];let _0x5cc12d={'consoleLog':()=>{},'consoleTrace':()=>{},'consoleTime':()=>{},'consoleTimeEnd':()=>{},'autoLog':()=>{},'autoLogMany':()=>{},'autoTraceMany':()=>{},'coverage':()=>{},'autoTrace':()=>{},'autoTime':()=>{},'autoTimeEnd':()=>{}};if(!X(_0x3a2e2f,_0x401541,_0x1f9e1f))return _0x3a2e2f[_0x515b3b(0x159)]=_0x5cc12d,_0x3a2e2f['_console_ninja'];let _0x42b35a=b(_0x3a2e2f),_0x296c2a=_0x42b35a[_0x515b3b(0xe7)],_0x2a60e4=_0x42b35a[_0x515b3b(0x1b0)],_0x35d19b=_0x42b35a[_0x515b3b(0x144)],_0x27f784={'hits':{},'ts':{}},_0xe99c32=J(_0x3a2e2f,_0x5d73ce,_0x27f784,_0x3db9d2,_0x4c4a1f,_0x1f9e1f===_0x515b3b(0x127)?G:void 0x0),_0x55cf04=(_0x45e375,_0x364ca4,_0x32aeb1,_0x1e2151,_0x5d4765,_0x57f011)=>{var _0xff4a39=_0x515b3b;let _0x3c1e8c=_0x3a2e2f[_0xff4a39(0x159)];try{return _0x3a2e2f[_0xff4a39(0x159)]=_0x5cc12d,_0xe99c32(_0x45e375,_0x364ca4,_0x32aeb1,_0x1e2151,_0x5d4765,_0x57f011);}finally{_0x3a2e2f[_0xff4a39(0x159)]=_0x3c1e8c;}},_0x105a2e=_0x2eaff9=>{_0x27f784['ts'][_0x2eaff9]=_0x2a60e4();},_0xb863b3=(_0xd15b94,_0x21e22e)=>{var _0x241bb9=_0x515b3b;let _0x1ad3eb=_0x27f784['ts'][_0x21e22e];if(delete _0x27f784['ts'][_0x21e22e],_0x1ad3eb){let _0x3a9486=_0x296c2a(_0x1ad3eb,_0x2a60e4());_0x95aaa9(_0x55cf04(_0x241bb9(0x167),_0xd15b94,_0x35d19b(),_0x10b036,[_0x3a9486],_0x21e22e));}},_0x5dd4d1=_0x15c760=>{var _0x59b186=_0x515b3b,_0x18675c;return _0x1f9e1f==='next.js'&&_0x3a2e2f[_0x59b186(0x169)]&&((_0x18675c=_0x15c760==null?void 0x0:_0x15c760[_0x59b186(0x106)])==null?void 0x0:_0x18675c['length'])&&(_0x15c760['args'][0x0]['origin']=_0x3a2e2f['origin']),_0x15c760;};_0x3a2e2f['_console_ninja']={'consoleLog':(_0x20fe68,_0x1d70ef)=>{var _0x2de989=_0x515b3b;_0x3a2e2f[_0x2de989(0x131)][_0x2de989(0x180)][_0x2de989(0x12a)]!==_0x2de989(0x1d1)&&_0x95aaa9(_0x55cf04('log',_0x20fe68,_0x35d19b(),_0x10b036,_0x1d70ef));},'consoleTrace':(_0x21d0ca,_0x23ebfa)=>{var _0x15aa0b=_0x515b3b,_0x15c555,_0x128ad9;_0x3a2e2f['console'][_0x15aa0b(0x180)]['name']!==_0x15aa0b(0xe3)&&((_0x128ad9=(_0x15c555=_0x3a2e2f[_0x15aa0b(0x1a0)])==null?void 0x0:_0x15c555['versions'])!=null&&_0x128ad9[_0x15aa0b(0x190)]&&(_0x3a2e2f[_0x15aa0b(0xf6)]=!0x0),_0x95aaa9(_0x5dd4d1(_0x55cf04(_0x15aa0b(0xf9),_0x21d0ca,_0x35d19b(),_0x10b036,_0x23ebfa))));},'consoleError':(_0x2ea382,_0x50005d)=>{_0x3a2e2f['_ninjaIgnoreNextError']=!0x0,_0x95aaa9(_0x5dd4d1(_0x55cf04('error',_0x2ea382,_0x35d19b(),_0x10b036,_0x50005d)));},'consoleTime':_0x458121=>{_0x105a2e(_0x458121);},'consoleTimeEnd':(_0xba02ae,_0x34e3b1)=>{_0xb863b3(_0x34e3b1,_0xba02ae);},'autoLog':(_0x2258bc,_0x5695f0)=>{var _0xe2a8fb=_0x515b3b;_0x95aaa9(_0x55cf04(_0xe2a8fb(0x180),_0x5695f0,_0x35d19b(),_0x10b036,[_0x2258bc]));},'autoLogMany':(_0x57b5ce,_0xdd70d2)=>{var _0x2a6756=_0x515b3b;_0x95aaa9(_0x55cf04(_0x2a6756(0x180),_0x57b5ce,_0x35d19b(),_0x10b036,_0xdd70d2));},'autoTrace':(_0x1f260d,_0x54f3ca)=>{_0x95aaa9(_0x5dd4d1(_0x55cf04('trace',_0x54f3ca,_0x35d19b(),_0x10b036,[_0x1f260d])));},'autoTraceMany':(_0x5d15fd,_0x4ef3ae)=>{var _0xd8fd41=_0x515b3b;_0x95aaa9(_0x5dd4d1(_0x55cf04(_0xd8fd41(0xf9),_0x5d15fd,_0x35d19b(),_0x10b036,_0x4ef3ae)));},'autoTime':(_0x585297,_0x280fb2,_0x7c23d2)=>{_0x105a2e(_0x7c23d2);},'autoTimeEnd':(_0x11193e,_0x259329,_0x3fd404)=>{_0xb863b3(_0x259329,_0x3fd404);},'coverage':_0xd851d8=>{_0x95aaa9({'method':'coverage','version':_0x3db9d2,'args':[{'id':_0xd851d8}]});}};let _0x95aaa9=H(_0x3a2e2f,_0x36d0b8,_0x13c80a,_0x5a69e4,_0x1f9e1f,_0x49429e,_0x569f40),_0x10b036=_0x3a2e2f[_0x515b3b(0x134)];return _0x3a2e2f[_0x515b3b(0x159)];})(globalThis,_0x13c709(0x16a),_0x13c709(0xff),_0x13c709(0x128),'webpack',_0x13c709(0x1ce),_0x13c709(0xfe),[\"localhost\",\"127.0.0.1\",\"example.cypress.io\",\"10.0.2.2\",\"Jovits-MacBook-Air.local\",\"192.168.1.26\"],_0x13c709(0x17b),_0x13c709(0xd2),_0x13c709(0xfc),_0x13c709(0x14d));");}catch(e){}};/* istanbul ignore next */function oo_oo(/**@type{any}**/i,/**@type{any}**/...v){try{oo_cm().consoleLog(i, v);}catch(e){} return v};/* istanbul ignore next */function oo_tr(/**@type{any}**/i,/**@type{any}**/...v){try{oo_cm().consoleTrace(i, v);}catch(e){} return v};/* istanbul ignore next */function oo_tx(/**@type{any}**/i,/**@type{any}**/...v){try{oo_cm().consoleError(i, v);}catch(e){} return v};/* istanbul ignore next */function oo_ts(/**@type{any}**/v){try{oo_cm().consoleTime(v);}catch(e){} return v;};/* istanbul ignore next */function oo_te(/**@type{any}**/v, /**@type{any}**/i){try{oo_cm().consoleTimeEnd(v, i);}catch(e){} return v;};/*eslint unicorn/no-abusive-eslint-disable:,eslint-comments/disable-enable-pair:,eslint-comments/no-unlimited-disable:,eslint-comments/no-aggregating-enable:,eslint-comments/no-duplicate-disable:,eslint-comments/no-unused-disable:,eslint-comments/no-unused-enable:,*/